//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { injectable } from "inversify";
import { CPLError, CPLErrorTypes } from "cpl-react-common/Helpers/CustomErrors";

import { CPLAuthClientBase } from "./CPLAuthClientBase";

export interface ICPLAuthAppVersionClient {

    /**
     * @param version (optional) 
     * @param build (optional) 
     * @param oSTypeID (optional) 
     * @return Success
     */
    getAppVersionDetails(version?: string | undefined, build?: string | undefined, oSTypeID?: number | undefined): Promise<AppVersionModel>;
}

@injectable()
export class CPLAuthAppVersionClient extends CPLAuthClientBase implements ICPLAuthAppVersionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param version (optional) 
     * @param build (optional) 
     * @param oSTypeID (optional) 
     * @return Success
     */
    getAppVersionDetails(version?: string | undefined, build?: string | undefined, oSTypeID?: number | undefined): Promise<AppVersionModel> {
        let url_ = this.baseUrl + "/api/AppVersion/GetAppVersionDetails?";
        if (version === null)
            throw new globalThis.Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        if (build === null)
            throw new globalThis.Error("The parameter 'build' cannot be null.");
        else if (build !== undefined)
            url_ += "build=" + encodeURIComponent("" + build) + "&";
        if (oSTypeID === null)
            throw new globalThis.Error("The parameter 'oSTypeID' cannot be null.");
        else if (oSTypeID !== undefined)
            url_ += "OSTypeID=" + encodeURIComponent("" + oSTypeID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAppVersionDetails(_response);
        });
    }

    protected processGetAppVersionDetails(response: Response): Promise<AppVersionModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppVersionModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<AppVersionModel>(null as any);
    }
}

export interface ICPLAuthAuthenticationClient {

    /**
     * @param body (optional) 
     * @return Success
     */
    verifyCPLUser(body?: LoginRequestModel | undefined): Promise<CPLConnectSessionTokensModel>;

    /**
     * @param body (optional) 
     * @return Success
     */
    validateClientPortalUser(body?: LoginRequestModel | undefined): Promise<TwoFactorAuthModel>;

    /**
     * @param body (optional) 
     * @return Success
     */
    verifyClientPortalUser(body?: LoginRequestModel | undefined): Promise<VerifyClientPortalUserResponse>;

    /**
     * @param verificationCode (optional) 
     * @param body (optional) 
     * @return Success
     */
    verifyImpersonationToken(verificationCode?: string | undefined, body?: ImpersonationTokenModel | undefined): Promise<VerifyClientPortalUserResponse>;

    /**
     * @param body (optional) 
     * @return Success
     */
    requestNewClientPortalUserVerificationCode(body?: LoginRequestModel | undefined): Promise<void>;

    /**
     * @param singleUseToken (optional) 
     * @return Success
     */
    verifyCPLExternalAccessUser(singleUseToken?: string | undefined): Promise<ExternalAccessTokenModel>;

    /**
     * @param body (optional) 
     * @return Success
     */
    refreshTokenForCPLUser(body?: CPLAuthTokenModel | undefined): Promise<CPLAuthTokenModel>;

    /**
     * @param body (optional) 
     * @return Success
     */
    refreshTokenForClientPortalUser(body?: CPLAuthTokenModel | undefined): Promise<CPLAuthTokenModel>;

    /**
     * @param singleUseToken (optional) 
     * @param body (optional) 
     * @return Success
     */
    refreshTokenForCPLExternalAccessUser(singleUseToken?: string | undefined, body?: ExternalAccessTokenModel | undefined): Promise<ExternalAccessTokenModel>;

    /**
     * @return Success
     */
    getNewCPLToken(): Promise<CPLAuthTokenModel>;

    /**
     * @return Success
     */
    getNewCPLImageToken(): Promise<CPLAuthTokenModel>;

    /**
     * @param loginToken (optional) 
     * @return Success
     */
    verifyCPLUserFromLoginToken(loginToken?: string | undefined): Promise<CPLConnectSessionTokensModel>;
}

@injectable()
export class CPLAuthAuthenticationClient extends CPLAuthClientBase implements ICPLAuthAuthenticationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifyCPLUser(body?: LoginRequestModel | undefined): Promise<CPLConnectSessionTokensModel> {
        let url_ = this.baseUrl + "/api/Authentication/VerifyCPLUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVerifyCPLUser(_response);
        });
    }

    protected processVerifyCPLUser(response: Response): Promise<CPLConnectSessionTokensModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CPLConnectSessionTokensModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<CPLConnectSessionTokensModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateClientPortalUser(body?: LoginRequestModel | undefined): Promise<TwoFactorAuthModel> {
        let url_ = this.baseUrl + "/api/Authentication/ValidateClientPortalUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValidateClientPortalUser(_response);
        });
    }

    protected processValidateClientPortalUser(response: Response): Promise<TwoFactorAuthModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TwoFactorAuthModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<TwoFactorAuthModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifyClientPortalUser(body?: LoginRequestModel | undefined): Promise<VerifyClientPortalUserResponse> {
        let url_ = this.baseUrl + "/api/Authentication/VerifyClientPortalUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVerifyClientPortalUser(_response);
        });
    }

    protected processVerifyClientPortalUser(response: Response): Promise<VerifyClientPortalUserResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerifyClientPortalUserResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<VerifyClientPortalUserResponse>(null as any);
    }

    /**
     * @param verificationCode (optional) 
     * @param body (optional) 
     * @return Success
     */
    verifyImpersonationToken(verificationCode?: string | undefined, body?: ImpersonationTokenModel | undefined): Promise<VerifyClientPortalUserResponse> {
        let url_ = this.baseUrl + "/api/Authentication/VerifyImpersonationToken?";
        if (verificationCode === null)
            throw new globalThis.Error("The parameter 'verificationCode' cannot be null.");
        else if (verificationCode !== undefined)
            url_ += "verificationCode=" + encodeURIComponent("" + verificationCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVerifyImpersonationToken(_response);
        });
    }

    protected processVerifyImpersonationToken(response: Response): Promise<VerifyClientPortalUserResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerifyClientPortalUserResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<VerifyClientPortalUserResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    requestNewClientPortalUserVerificationCode(body?: LoginRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Authentication/RequestNewClientPortalUserVerificationCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRequestNewClientPortalUserVerificationCode(_response);
        });
    }

    protected processRequestNewClientPortalUserVerificationCode(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param singleUseToken (optional) 
     * @return Success
     */
    verifyCPLExternalAccessUser(singleUseToken?: string | undefined): Promise<ExternalAccessTokenModel> {
        let url_ = this.baseUrl + "/api/Authentication/VerifyCPLExternalAccessUser?";
        if (singleUseToken === null)
            throw new globalThis.Error("The parameter 'singleUseToken' cannot be null.");
        else if (singleUseToken !== undefined)
            url_ += "singleUseToken=" + encodeURIComponent("" + singleUseToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVerifyCPLExternalAccessUser(_response);
        });
    }

    protected processVerifyCPLExternalAccessUser(response: Response): Promise<ExternalAccessTokenModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAccessTokenModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ExternalAccessTokenModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    refreshTokenForCPLUser(body?: CPLAuthTokenModel | undefined): Promise<CPLAuthTokenModel> {
        let url_ = this.baseUrl + "/api/Authentication/RefreshTokenForCPLUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRefreshTokenForCPLUser(_response);
        });
    }

    protected processRefreshTokenForCPLUser(response: Response): Promise<CPLAuthTokenModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CPLAuthTokenModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<CPLAuthTokenModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    refreshTokenForClientPortalUser(body?: CPLAuthTokenModel | undefined): Promise<CPLAuthTokenModel> {
        let url_ = this.baseUrl + "/api/Authentication/RefreshTokenForClientPortalUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRefreshTokenForClientPortalUser(_response);
        });
    }

    protected processRefreshTokenForClientPortalUser(response: Response): Promise<CPLAuthTokenModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CPLAuthTokenModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<CPLAuthTokenModel>(null as any);
    }

    /**
     * @param singleUseToken (optional) 
     * @param body (optional) 
     * @return Success
     */
    refreshTokenForCPLExternalAccessUser(singleUseToken?: string | undefined, body?: ExternalAccessTokenModel | undefined): Promise<ExternalAccessTokenModel> {
        let url_ = this.baseUrl + "/api/Authentication/RefreshTokenForCPLExternalAccessUser?";
        if (singleUseToken === null)
            throw new globalThis.Error("The parameter 'singleUseToken' cannot be null.");
        else if (singleUseToken !== undefined)
            url_ += "singleUseToken=" + encodeURIComponent("" + singleUseToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRefreshTokenForCPLExternalAccessUser(_response);
        });
    }

    protected processRefreshTokenForCPLExternalAccessUser(response: Response): Promise<ExternalAccessTokenModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAccessTokenModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ExternalAccessTokenModel>(null as any);
    }

    /**
     * @return Success
     */
    getNewCPLToken(): Promise<CPLAuthTokenModel> {
        let url_ = this.baseUrl + "/api/Authentication/GetNewCPLToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNewCPLToken(_response);
        });
    }

    protected processGetNewCPLToken(response: Response): Promise<CPLAuthTokenModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CPLAuthTokenModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<CPLAuthTokenModel>(null as any);
    }

    /**
     * @return Success
     */
    getNewCPLImageToken(): Promise<CPLAuthTokenModel> {
        let url_ = this.baseUrl + "/api/Authentication/GetNewCPLImageToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNewCPLImageToken(_response);
        });
    }

    protected processGetNewCPLImageToken(response: Response): Promise<CPLAuthTokenModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CPLAuthTokenModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<CPLAuthTokenModel>(null as any);
    }

    /**
     * @param loginToken (optional) 
     * @return Success
     */
    verifyCPLUserFromLoginToken(loginToken?: string | undefined): Promise<CPLConnectSessionTokensModel> {
        let url_ = this.baseUrl + "/api/Authentication/VerifyCPLUserFromLoginToken?";
        if (loginToken === null)
            throw new globalThis.Error("The parameter 'loginToken' cannot be null.");
        else if (loginToken !== undefined)
            url_ += "loginToken=" + encodeURIComponent("" + loginToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVerifyCPLUserFromLoginToken(_response);
        });
    }

    protected processVerifyCPLUserFromLoginToken(response: Response): Promise<CPLConnectSessionTokensModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CPLConnectSessionTokensModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<CPLConnectSessionTokensModel>(null as any);
    }
}

export interface ICPLAuthBlinkClient {

    /**
     * @param transaction_id (optional) 
     * @param status (optional) 
     * @param note (optional) 
     * @param companyID (optional) 
     * @param clientPortalPaymentID (optional) 
     * @return Success
     */
    transactionComplete(transaction_id?: string | undefined, status?: string | undefined, note?: string | undefined, companyID?: string | undefined, clientPortalPaymentID?: string | undefined): Promise<void>;

    /**
     * @param companyID (optional) 
     * @return Success
     */
    transactionStatusUpdate(companyID?: string | undefined): Promise<void>;
}

@injectable()
export class CPLAuthBlinkClient extends CPLAuthClientBase implements ICPLAuthBlinkClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param transaction_id (optional) 
     * @param status (optional) 
     * @param note (optional) 
     * @param companyID (optional) 
     * @param clientPortalPaymentID (optional) 
     * @return Success
     */
    transactionComplete(transaction_id?: string | undefined, status?: string | undefined, note?: string | undefined, companyID?: string | undefined, clientPortalPaymentID?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Blink/TransactionComplete?";
        if (transaction_id === null)
            throw new globalThis.Error("The parameter 'transaction_id' cannot be null.");
        else if (transaction_id !== undefined)
            url_ += "transaction_id=" + encodeURIComponent("" + transaction_id) + "&";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (note === null)
            throw new globalThis.Error("The parameter 'note' cannot be null.");
        else if (note !== undefined)
            url_ += "note=" + encodeURIComponent("" + note) + "&";
        if (companyID === null)
            throw new globalThis.Error("The parameter 'companyID' cannot be null.");
        else if (companyID !== undefined)
            url_ += "companyID=" + encodeURIComponent("" + companyID) + "&";
        if (clientPortalPaymentID === null)
            throw new globalThis.Error("The parameter 'clientPortalPaymentID' cannot be null.");
        else if (clientPortalPaymentID !== undefined)
            url_ += "clientPortalPaymentID=" + encodeURIComponent("" + clientPortalPaymentID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTransactionComplete(_response);
        });
    }

    protected processTransactionComplete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param companyID (optional) 
     * @return Success
     */
    transactionStatusUpdate(companyID?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Blink/TransactionStatusUpdate?";
        if (companyID === null)
            throw new globalThis.Error("The parameter 'companyID' cannot be null.");
        else if (companyID !== undefined)
            url_ += "companyID=" + encodeURIComponent("" + companyID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTransactionStatusUpdate(_response);
        });
    }

    protected processTransactionStatusUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICPLAuthClientPortalCookiesClient {

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCookiePreferences(body?: ClientPortalCookiePreferencesModel | undefined): Promise<void>;
}

@injectable()
export class CPLAuthClientPortalCookiesClient extends CPLAuthClientBase implements ICPLAuthClientPortalCookiesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCookiePreferences(body?: ClientPortalCookiePreferencesModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalCookies/UpdateCookiePreferences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCookiePreferences(_response);
        });
    }

    protected processUpdateCookiePreferences(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICPLAuthClientPortalUserLogsClient {

    /**
     * @param body (optional) 
     * @return Success
     */
    log(body?: ClientPortalUserLogModel | undefined): Promise<void>;
}

@injectable()
export class CPLAuthClientPortalUserLogsClient extends CPLAuthClientBase implements ICPLAuthClientPortalUserLogsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    log(body?: ClientPortalUserLogModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalUserLogs/Log";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLog(_response);
        });
    }

    protected processLog(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICPLAuthClientPortalUsersClient {

    /**
     * @param clientPortalUserID (optional) 
     * @return Success
     */
    getClientPortalUser(clientPortalUserID?: string | undefined): Promise<ClientPortalUserModel>;

    /**
     * @return Success
     */
    getProfile(): Promise<ClientPortalUserModel>;

    /**
     * @param clientPortalUserID (optional) 
     * @return Success
     */
    enableClientPortalUser(clientPortalUserID?: string | undefined): Promise<void>;

    /**
     * @param clientPortalUserID (optional) 
     * @return Success
     */
    disableClientPortalUser(clientPortalUserID?: string | undefined): Promise<void>;

    /**
     * @return Success
     */
    acceptTermsAndConditions(): Promise<void>;

    /**
     * @return Success
     */
    getTwoFactorAuthSetupData(): Promise<TwoFactorAuthSetupModel>;

    /**
     * @param oneTimePassword (optional) 
     * @return Success
     */
    verifyOneTimePasswordSetup(oneTimePassword?: string | undefined): Promise<boolean>;

    /**
     * @return Success
     */
    sendTwoFactorAuthEmailSetupCode(): Promise<void>;

    /**
     * @param verificationCode (optional) 
     * @return Success
     */
    verifyTwoFactorAuthEmailSetup(verificationCode?: string | undefined): Promise<boolean>;

    /**
     * @param emailAddress (optional) 
     * @param companyID (optional) 
     * @return Success
     */
    sendEmailVerificationCode(emailAddress?: string | undefined, companyID?: string | undefined): Promise<void>;

    /**
     * @param emailAddress (optional) 
     * @param verificationCode (optional) 
     * @param companyID (optional) 
     * @return Success
     */
    verifyEmail(emailAddress?: string | undefined, verificationCode?: string | undefined, companyID?: string | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    createNewClientPortalUser(body?: NewClientPortalUserModel | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    changeClientPortalUserDetails(body?: ClientPortalUserDetailsModel | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    changeClientPortalUserPassword(body?: string | undefined): Promise<void>;

    /**
     * @return Success
     */
    getClientPortalUsers(): Promise<ClientPortalUserModel[]>;

    /**
     * @param emailAddress (optional) 
     * @param verificationCode (optional) 
     * @param companyID (optional) 
     * @return Success
     */
    changeClientPortalUserEmail(emailAddress?: string | undefined, verificationCode?: string | undefined, companyID?: string | undefined): Promise<void>;

    /**
     * @param clientAccountNumber (optional) 
     * @param emailAddress (optional) 
     * @return Success
     */
    linkClientAccount(clientAccountNumber?: string | undefined, emailAddress?: string | undefined): Promise<boolean>;

    /**
     * @param clientPortalUserID (optional) 
     * @param companyID (optional) 
     * @return Success
     */
    getLinkedClientAccounts(clientPortalUserID?: string | undefined, companyID?: string | undefined): Promise<ClientPortalLinkedClientAccountModel[]>;

    /**
     * @param clientPortalUserClientMappingID (optional) 
     * @return Success
     */
    deleteClientAccountLink(clientPortalUserClientMappingID?: number | undefined): Promise<void>;

    /**
     * @param clientPortalUserID (optional) 
     * @param clientID (optional) 
     * @return Success
     */
    unlinkClientAccount(clientPortalUserID?: string | undefined, clientID?: string | undefined): Promise<void>;

    /**
     * @param passwordChangeRequired (optional) 
     * @param clientPortalUserID (optional) 
     * @return Success
     */
    setPasswordChangeRequired(passwordChangeRequired?: boolean | undefined, clientPortalUserID?: string | undefined): Promise<void>;

    /**
     * @return Success
     */
    onTermsAndConditionsChanged(): Promise<void>;

    /**
     * @param emailAddress (optional) 
     * @return Success
     */
    resetPassword(emailAddress?: string | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    externalPasswordChange(body?: ExternalPasswordChangeModel | undefined): Promise<void>;

    /**
     * @return Success
     */
    deleteClientPortalUser(): Promise<boolean>;
}

@injectable()
export class CPLAuthClientPortalUsersClient extends CPLAuthClientBase implements ICPLAuthClientPortalUsersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param clientPortalUserID (optional) 
     * @return Success
     */
    getClientPortalUser(clientPortalUserID?: string | undefined): Promise<ClientPortalUserModel> {
        let url_ = this.baseUrl + "/api/ClientPortalUsers/GetClientPortalUser?";
        if (clientPortalUserID === null)
            throw new globalThis.Error("The parameter 'clientPortalUserID' cannot be null.");
        else if (clientPortalUserID !== undefined)
            url_ += "clientPortalUserID=" + encodeURIComponent("" + clientPortalUserID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientPortalUser(_response);
        });
    }

    protected processGetClientPortalUser(response: Response): Promise<ClientPortalUserModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientPortalUserModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientPortalUserModel>(null as any);
    }

    /**
     * @return Success
     */
    getProfile(): Promise<ClientPortalUserModel> {
        let url_ = this.baseUrl + "/api/ClientPortalUsers/GetProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProfile(_response);
        });
    }

    protected processGetProfile(response: Response): Promise<ClientPortalUserModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientPortalUserModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientPortalUserModel>(null as any);
    }

    /**
     * @param clientPortalUserID (optional) 
     * @return Success
     */
    enableClientPortalUser(clientPortalUserID?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalUsers/EnableClientPortalUser?";
        if (clientPortalUserID === null)
            throw new globalThis.Error("The parameter 'clientPortalUserID' cannot be null.");
        else if (clientPortalUserID !== undefined)
            url_ += "clientPortalUserID=" + encodeURIComponent("" + clientPortalUserID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEnableClientPortalUser(_response);
        });
    }

    protected processEnableClientPortalUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param clientPortalUserID (optional) 
     * @return Success
     */
    disableClientPortalUser(clientPortalUserID?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalUsers/DisableClientPortalUser?";
        if (clientPortalUserID === null)
            throw new globalThis.Error("The parameter 'clientPortalUserID' cannot be null.");
        else if (clientPortalUserID !== undefined)
            url_ += "clientPortalUserID=" + encodeURIComponent("" + clientPortalUserID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDisableClientPortalUser(_response);
        });
    }

    protected processDisableClientPortalUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    acceptTermsAndConditions(): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalUsers/AcceptTermsAndConditions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAcceptTermsAndConditions(_response);
        });
    }

    protected processAcceptTermsAndConditions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getTwoFactorAuthSetupData(): Promise<TwoFactorAuthSetupModel> {
        let url_ = this.baseUrl + "/api/ClientPortalUsers/GetTwoFactorAuthSetupData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTwoFactorAuthSetupData(_response);
        });
    }

    protected processGetTwoFactorAuthSetupData(response: Response): Promise<TwoFactorAuthSetupModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TwoFactorAuthSetupModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<TwoFactorAuthSetupModel>(null as any);
    }

    /**
     * @param oneTimePassword (optional) 
     * @return Success
     */
    verifyOneTimePasswordSetup(oneTimePassword?: string | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ClientPortalUsers/VerifyOneTimePasswordSetup?";
        if (oneTimePassword === null)
            throw new globalThis.Error("The parameter 'oneTimePassword' cannot be null.");
        else if (oneTimePassword !== undefined)
            url_ += "oneTimePassword=" + encodeURIComponent("" + oneTimePassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVerifyOneTimePasswordSetup(_response);
        });
    }

    protected processVerifyOneTimePasswordSetup(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    sendTwoFactorAuthEmailSetupCode(): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalUsers/SendTwoFactorAuthEmailSetupCode";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendTwoFactorAuthEmailSetupCode(_response);
        });
    }

    protected processSendTwoFactorAuthEmailSetupCode(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param verificationCode (optional) 
     * @return Success
     */
    verifyTwoFactorAuthEmailSetup(verificationCode?: string | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ClientPortalUsers/VerifyTwoFactorAuthEmailSetup?";
        if (verificationCode === null)
            throw new globalThis.Error("The parameter 'verificationCode' cannot be null.");
        else if (verificationCode !== undefined)
            url_ += "verificationCode=" + encodeURIComponent("" + verificationCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVerifyTwoFactorAuthEmailSetup(_response);
        });
    }

    protected processVerifyTwoFactorAuthEmailSetup(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param emailAddress (optional) 
     * @param companyID (optional) 
     * @return Success
     */
    sendEmailVerificationCode(emailAddress?: string | undefined, companyID?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalUsers/SendEmailVerificationCode?";
        if (emailAddress === null)
            throw new globalThis.Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        if (companyID === null)
            throw new globalThis.Error("The parameter 'companyID' cannot be null.");
        else if (companyID !== undefined)
            url_ += "companyID=" + encodeURIComponent("" + companyID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendEmailVerificationCode(_response);
        });
    }

    protected processSendEmailVerificationCode(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param emailAddress (optional) 
     * @param verificationCode (optional) 
     * @param companyID (optional) 
     * @return Success
     */
    verifyEmail(emailAddress?: string | undefined, verificationCode?: string | undefined, companyID?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalUsers/VerifyEmail?";
        if (emailAddress === null)
            throw new globalThis.Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        if (verificationCode === null)
            throw new globalThis.Error("The parameter 'verificationCode' cannot be null.");
        else if (verificationCode !== undefined)
            url_ += "verificationCode=" + encodeURIComponent("" + verificationCode) + "&";
        if (companyID === null)
            throw new globalThis.Error("The parameter 'companyID' cannot be null.");
        else if (companyID !== undefined)
            url_ += "companyID=" + encodeURIComponent("" + companyID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVerifyEmail(_response);
        });
    }

    protected processVerifyEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createNewClientPortalUser(body?: NewClientPortalUserModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalUsers/CreateNewClientPortalUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateNewClientPortalUser(_response);
        });
    }

    protected processCreateNewClientPortalUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeClientPortalUserDetails(body?: ClientPortalUserDetailsModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalUsers/ChangeClientPortalUserDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangeClientPortalUserDetails(_response);
        });
    }

    protected processChangeClientPortalUserDetails(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeClientPortalUserPassword(body?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalUsers/ChangeClientPortalUserPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangeClientPortalUserPassword(_response);
        });
    }

    protected processChangeClientPortalUserPassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getClientPortalUsers(): Promise<ClientPortalUserModel[]> {
        let url_ = this.baseUrl + "/api/ClientPortalUsers/GetClientPortalUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientPortalUsers(_response);
        });
    }

    protected processGetClientPortalUsers(response: Response): Promise<ClientPortalUserModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientPortalUserModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientPortalUserModel[]>(null as any);
    }

    /**
     * @param emailAddress (optional) 
     * @param verificationCode (optional) 
     * @param companyID (optional) 
     * @return Success
     */
    changeClientPortalUserEmail(emailAddress?: string | undefined, verificationCode?: string | undefined, companyID?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalUsers/ChangeClientPortalUserEmail?";
        if (emailAddress === null)
            throw new globalThis.Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        if (verificationCode === null)
            throw new globalThis.Error("The parameter 'verificationCode' cannot be null.");
        else if (verificationCode !== undefined)
            url_ += "verificationCode=" + encodeURIComponent("" + verificationCode) + "&";
        if (companyID === null)
            throw new globalThis.Error("The parameter 'companyID' cannot be null.");
        else if (companyID !== undefined)
            url_ += "companyID=" + encodeURIComponent("" + companyID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangeClientPortalUserEmail(_response);
        });
    }

    protected processChangeClientPortalUserEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param clientAccountNumber (optional) 
     * @param emailAddress (optional) 
     * @return Success
     */
    linkClientAccount(clientAccountNumber?: string | undefined, emailAddress?: string | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ClientPortalUsers/LinkClientAccount?";
        if (clientAccountNumber === null)
            throw new globalThis.Error("The parameter 'clientAccountNumber' cannot be null.");
        else if (clientAccountNumber !== undefined)
            url_ += "clientAccountNumber=" + encodeURIComponent("" + clientAccountNumber) + "&";
        if (emailAddress === null)
            throw new globalThis.Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLinkClientAccount(_response);
        });
    }

    protected processLinkClientAccount(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param clientPortalUserID (optional) 
     * @param companyID (optional) 
     * @return Success
     */
    getLinkedClientAccounts(clientPortalUserID?: string | undefined, companyID?: string | undefined): Promise<ClientPortalLinkedClientAccountModel[]> {
        let url_ = this.baseUrl + "/api/ClientPortalUsers/GetLinkedClientAccounts?";
        if (clientPortalUserID === null)
            throw new globalThis.Error("The parameter 'clientPortalUserID' cannot be null.");
        else if (clientPortalUserID !== undefined)
            url_ += "clientPortalUserID=" + encodeURIComponent("" + clientPortalUserID) + "&";
        if (companyID === null)
            throw new globalThis.Error("The parameter 'companyID' cannot be null.");
        else if (companyID !== undefined)
            url_ += "companyID=" + encodeURIComponent("" + companyID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLinkedClientAccounts(_response);
        });
    }

    protected processGetLinkedClientAccounts(response: Response): Promise<ClientPortalLinkedClientAccountModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientPortalLinkedClientAccountModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ClientPortalLinkedClientAccountModel[]>(null as any);
    }

    /**
     * @param clientPortalUserClientMappingID (optional) 
     * @return Success
     */
    deleteClientAccountLink(clientPortalUserClientMappingID?: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalUsers/DeleteClientAccountLink?";
        if (clientPortalUserClientMappingID === null)
            throw new globalThis.Error("The parameter 'clientPortalUserClientMappingID' cannot be null.");
        else if (clientPortalUserClientMappingID !== undefined)
            url_ += "clientPortalUserClientMappingID=" + encodeURIComponent("" + clientPortalUserClientMappingID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteClientAccountLink(_response);
        });
    }

    protected processDeleteClientAccountLink(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param clientPortalUserID (optional) 
     * @param clientID (optional) 
     * @return Success
     */
    unlinkClientAccount(clientPortalUserID?: string | undefined, clientID?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalUsers/UnlinkClientAccount?";
        if (clientPortalUserID === null)
            throw new globalThis.Error("The parameter 'clientPortalUserID' cannot be null.");
        else if (clientPortalUserID !== undefined)
            url_ += "clientPortalUserID=" + encodeURIComponent("" + clientPortalUserID) + "&";
        if (clientID === null)
            throw new globalThis.Error("The parameter 'clientID' cannot be null.");
        else if (clientID !== undefined)
            url_ += "clientID=" + encodeURIComponent("" + clientID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnlinkClientAccount(_response);
        });
    }

    protected processUnlinkClientAccount(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param passwordChangeRequired (optional) 
     * @param clientPortalUserID (optional) 
     * @return Success
     */
    setPasswordChangeRequired(passwordChangeRequired?: boolean | undefined, clientPortalUserID?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalUsers/SetPasswordChangeRequired?";
        if (passwordChangeRequired === null)
            throw new globalThis.Error("The parameter 'passwordChangeRequired' cannot be null.");
        else if (passwordChangeRequired !== undefined)
            url_ += "passwordChangeRequired=" + encodeURIComponent("" + passwordChangeRequired) + "&";
        if (clientPortalUserID === null)
            throw new globalThis.Error("The parameter 'clientPortalUserID' cannot be null.");
        else if (clientPortalUserID !== undefined)
            url_ += "clientPortalUserID=" + encodeURIComponent("" + clientPortalUserID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetPasswordChangeRequired(_response);
        });
    }

    protected processSetPasswordChangeRequired(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    onTermsAndConditionsChanged(): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalUsers/OnTermsAndConditionsChanged";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processOnTermsAndConditionsChanged(_response);
        });
    }

    protected processOnTermsAndConditionsChanged(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param emailAddress (optional) 
     * @return Success
     */
    resetPassword(emailAddress?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalUsers/ResetPassword?";
        if (emailAddress === null)
            throw new globalThis.Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalPasswordChange(body?: ExternalPasswordChangeModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ClientPortalUsers/ExternalPasswordChange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExternalPasswordChange(_response);
        });
    }

    protected processExternalPasswordChange(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteClientPortalUser(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ClientPortalUsers/DeleteClientPortalUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteClientPortalUser(_response);
        });
    }

    protected processDeleteClientPortalUser(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export interface ICPLAuthCompaniesClient {

    /**
     * @param clientWebPortalAddress (optional) 
     * @return Success
     */
    getCompanyIDFromClientWebPortalAddress(clientWebPortalAddress?: string | undefined): Promise<string>;

    /**
     * @return Success
     */
    getClientPortalOrigins(): Promise<string[]>;

    /**
     * @return Success
     */
    getClientPortalCompanies(): Promise<CompanyModel[]>;

    /**
     * @param emailAddress (optional) 
     * @return Success
     */
    getClientPortalCompaniesByEmail(emailAddress?: string | undefined): Promise<CompanyModel[]>;
}

@injectable()
export class CPLAuthCompaniesClient extends CPLAuthClientBase implements ICPLAuthCompaniesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param clientWebPortalAddress (optional) 
     * @return Success
     */
    getCompanyIDFromClientWebPortalAddress(clientWebPortalAddress?: string | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Companies/GetCompanyIDFromClientWebPortalAddress?";
        if (clientWebPortalAddress === null)
            throw new globalThis.Error("The parameter 'clientWebPortalAddress' cannot be null.");
        else if (clientWebPortalAddress !== undefined)
            url_ += "clientWebPortalAddress=" + encodeURIComponent("" + clientWebPortalAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyIDFromClientWebPortalAddress(_response);
        });
    }

    protected processGetCompanyIDFromClientWebPortalAddress(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    getClientPortalOrigins(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Companies/GetClientPortalOrigins";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientPortalOrigins(_response);
        });
    }

    protected processGetClientPortalOrigins(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @return Success
     */
    getClientPortalCompanies(): Promise<CompanyModel[]> {
        let url_ = this.baseUrl + "/api/Companies/GetClientPortalCompanies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientPortalCompanies(_response);
        });
    }

    protected processGetClientPortalCompanies(response: Response): Promise<CompanyModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanyModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<CompanyModel[]>(null as any);
    }

    /**
     * @param emailAddress (optional) 
     * @return Success
     */
    getClientPortalCompaniesByEmail(emailAddress?: string | undefined): Promise<CompanyModel[]> {
        let url_ = this.baseUrl + "/api/Companies/GetClientPortalCompaniesByEmail?";
        if (emailAddress === null)
            throw new globalThis.Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClientPortalCompaniesByEmail(_response);
        });
    }

    protected processGetClientPortalCompaniesByEmail(response: Response): Promise<CompanyModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanyModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<CompanyModel[]>(null as any);
    }
}

export interface ICPLAuthCompanyBrandingClient {

    /**
     * @return Success
     */
    getCompanyBranding(): Promise<CompanyBrandingModel>;

    /**
     * @param companyID (optional) 
     * @return Success
     */
    getCompanyBrandingForCompany(companyID?: string | undefined): Promise<CompanyBrandingModel>;

    /**
     * @param logo (optional) 
     * @param favicon (optional) 
     * @param bodyFont (optional) 
     * @param headerFont (optional) 
     * @param companyBrandingFile (optional) 
     * @param isGeneratedCSSFile (optional) 
     * @param clientPortalName (optional) 
     * @param navbarBackgroundColour (optional) 
     * @param navbarTextColour (optional) 
     * @param navbarButtonColour (optional) 
     * @param navbarButtonTextColour (optional) 
     * @param navbarIconColour (optional) 
     * @param footerBackgroundColour (optional) 
     * @param footerTextColour (optional) 
     * @param footerButtonColour (optional) 
     * @param footerButtonTextColour (optional) 
     * @param toolbarBackgroundColour (optional) 
     * @param toolbarTextColour (optional) 
     * @param toolbarButtonColour (optional) 
     * @param toolbarButtonTextColour (optional) 
     * @param buttonPrimaryColour (optional) 
     * @param buttonSecondaryColour (optional) 
     * @param buttonSuccessColour (optional) 
     * @param buttonDangerColour (optional) 
     * @param buttonPrimaryTextColour (optional) 
     * @param buttonSecondaryTextColour (optional) 
     * @param buttonSuccessTextColour (optional) 
     * @param buttonDangerTextColour (optional) 
     * @param brandPrimaryColour (optional) 
     * @param brandSecondaryColour (optional) 
     * @param brandTertiaryColour (optional) 
     * @param fontHeadingColour (optional) 
     * @param fontBodyColour (optional) 
     * @param isHeaderTextBold (optional) 
     * @param isHeaderTextItalic (optional) 
     * @param isHeaderTextUnderlined (optional) 
     * @return Success
     */
    createNewCompanyBranding(formData: { logo?: FileParameter | null | undefined, favicon?: FileParameter | null | undefined, bodyFont?: FileParameter | null | undefined, headerFont?: FileParameter | null | undefined, companyBrandingFile?: FileParameter | null | undefined, isGeneratedCSSFile?: boolean | undefined, clientPortalName?: string | null | undefined, navbarBackgroundColour?: string | null | undefined, navbarTextColour?: string | null | undefined, navbarButtonColour?: string | null | undefined, navbarButtonTextColour?: string | null | undefined, navbarIconColour?: string | null | undefined, footerBackgroundColour?: string | null | undefined, footerTextColour?: string | null | undefined, footerButtonColour?: string | null | undefined, footerButtonTextColour?: string | null | undefined, toolbarBackgroundColour?: string | null | undefined, toolbarTextColour?: string | null | undefined, toolbarButtonColour?: string | null | undefined, toolbarButtonTextColour?: string | null | undefined, buttonPrimaryColour?: string | null | undefined, buttonSecondaryColour?: string | null | undefined, buttonSuccessColour?: string | null | undefined, buttonDangerColour?: string | null | undefined, buttonPrimaryTextColour?: string | null | undefined, buttonSecondaryTextColour?: string | null | undefined, buttonSuccessTextColour?: string | null | undefined, buttonDangerTextColour?: string | null | undefined, brandPrimaryColour?: string | null | undefined, brandSecondaryColour?: string | null | undefined, brandTertiaryColour?: string | null | undefined, fontHeadingColour?: string | null | undefined, fontBodyColour?: string | null | undefined, isHeaderTextBold?: boolean | undefined, isHeaderTextItalic?: boolean | undefined, isHeaderTextUnderlined?: boolean | undefined }): Promise<void>;

    /**
     * @param companyBrandingID (optional) 
     * @param logo (optional) 
     * @param favicon (optional) 
     * @param bodyFont (optional) 
     * @param headerFont (optional) 
     * @param companyBrandingFile (optional) 
     * @param isGeneratedCSSFile (optional) 
     * @param clientPortalName (optional) 
     * @param navbarBackgroundColour (optional) 
     * @param navbarTextColour (optional) 
     * @param navbarButtonColour (optional) 
     * @param navbarButtonTextColour (optional) 
     * @param navbarIconColour (optional) 
     * @param footerBackgroundColour (optional) 
     * @param footerTextColour (optional) 
     * @param footerButtonColour (optional) 
     * @param footerButtonTextColour (optional) 
     * @param toolbarBackgroundColour (optional) 
     * @param toolbarTextColour (optional) 
     * @param toolbarButtonColour (optional) 
     * @param toolbarButtonTextColour (optional) 
     * @param buttonPrimaryColour (optional) 
     * @param buttonSecondaryColour (optional) 
     * @param buttonSuccessColour (optional) 
     * @param buttonDangerColour (optional) 
     * @param buttonPrimaryTextColour (optional) 
     * @param buttonSecondaryTextColour (optional) 
     * @param buttonSuccessTextColour (optional) 
     * @param buttonDangerTextColour (optional) 
     * @param brandPrimaryColour (optional) 
     * @param brandSecondaryColour (optional) 
     * @param brandTertiaryColour (optional) 
     * @param fontHeadingColour (optional) 
     * @param fontBodyColour (optional) 
     * @param isHeaderTextBold (optional) 
     * @param isHeaderTextItalic (optional) 
     * @param isHeaderTextUnderlined (optional) 
     * @return Success
     */
    updateCompanyBranding(formData: { companyBrandingID?: number | undefined, logo?: FileParameter | null | undefined, favicon?: FileParameter | null | undefined, bodyFont?: FileParameter | null | undefined, headerFont?: FileParameter | null | undefined, companyBrandingFile?: FileParameter | null | undefined, isGeneratedCSSFile?: boolean | undefined, clientPortalName?: string | null | undefined, navbarBackgroundColour?: string | null | undefined, navbarTextColour?: string | null | undefined, navbarButtonColour?: string | null | undefined, navbarButtonTextColour?: string | null | undefined, navbarIconColour?: string | null | undefined, footerBackgroundColour?: string | null | undefined, footerTextColour?: string | null | undefined, footerButtonColour?: string | null | undefined, footerButtonTextColour?: string | null | undefined, toolbarBackgroundColour?: string | null | undefined, toolbarTextColour?: string | null | undefined, toolbarButtonColour?: string | null | undefined, toolbarButtonTextColour?: string | null | undefined, buttonPrimaryColour?: string | null | undefined, buttonSecondaryColour?: string | null | undefined, buttonSuccessColour?: string | null | undefined, buttonDangerColour?: string | null | undefined, buttonPrimaryTextColour?: string | null | undefined, buttonSecondaryTextColour?: string | null | undefined, buttonSuccessTextColour?: string | null | undefined, buttonDangerTextColour?: string | null | undefined, brandPrimaryColour?: string | null | undefined, brandSecondaryColour?: string | null | undefined, brandTertiaryColour?: string | null | undefined, fontHeadingColour?: string | null | undefined, fontBodyColour?: string | null | undefined, isHeaderTextBold?: boolean | undefined, isHeaderTextItalic?: boolean | undefined, isHeaderTextUnderlined?: boolean | undefined }): Promise<void>;

    /**
     * @param companyID (optional) 
     * @return Success
     */
    getCompanyBrandingCSSFileURL(companyID?: string | undefined): Promise<CompanyBrandingUrlModel>;

    /**
     * @return Success
     */
    getCompanyLoginScreenNarrative(): Promise<LoginScreenNarrativeModel>;

    /**
     * @param companyID (optional) 
     * @return Success
     */
    getCompanyLoginScreenNarrativeForCompany(companyID?: string | undefined): Promise<LoginScreenNarrativeModel>;

    /**
     * @param loginScreenNarrative (optional) 
     * @return Success
     */
    createNewCompanyLoginScreenNarrative(loginScreenNarrative?: string | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCompanyLoginScreenNarrative(body?: LoginScreenNarrativeModel | undefined): Promise<void>;
}

@injectable()
export class CPLAuthCompanyBrandingClient extends CPLAuthClientBase implements ICPLAuthCompanyBrandingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getCompanyBranding(): Promise<CompanyBrandingModel> {
        let url_ = this.baseUrl + "/api/CompanyBranding/GetCompanyBranding";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyBranding(_response);
        });
    }

    protected processGetCompanyBranding(response: Response): Promise<CompanyBrandingModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyBrandingModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<CompanyBrandingModel>(null as any);
    }

    /**
     * @param companyID (optional) 
     * @return Success
     */
    getCompanyBrandingForCompany(companyID?: string | undefined): Promise<CompanyBrandingModel> {
        let url_ = this.baseUrl + "/api/CompanyBranding/GetCompanyBrandingForCompany?";
        if (companyID === null)
            throw new globalThis.Error("The parameter 'companyID' cannot be null.");
        else if (companyID !== undefined)
            url_ += "companyID=" + encodeURIComponent("" + companyID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyBrandingForCompany(_response);
        });
    }

    protected processGetCompanyBrandingForCompany(response: Response): Promise<CompanyBrandingModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyBrandingModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<CompanyBrandingModel>(null as any);
    }

    /**
     * @param logo (optional) 
     * @param favicon (optional) 
     * @param bodyFont (optional) 
     * @param headerFont (optional) 
     * @param companyBrandingFile (optional) 
     * @param isGeneratedCSSFile (optional) 
     * @param clientPortalName (optional) 
     * @param navbarBackgroundColour (optional) 
     * @param navbarTextColour (optional) 
     * @param navbarButtonColour (optional) 
     * @param navbarButtonTextColour (optional) 
     * @param navbarIconColour (optional) 
     * @param footerBackgroundColour (optional) 
     * @param footerTextColour (optional) 
     * @param footerButtonColour (optional) 
     * @param footerButtonTextColour (optional) 
     * @param toolbarBackgroundColour (optional) 
     * @param toolbarTextColour (optional) 
     * @param toolbarButtonColour (optional) 
     * @param toolbarButtonTextColour (optional) 
     * @param buttonPrimaryColour (optional) 
     * @param buttonSecondaryColour (optional) 
     * @param buttonSuccessColour (optional) 
     * @param buttonDangerColour (optional) 
     * @param buttonPrimaryTextColour (optional) 
     * @param buttonSecondaryTextColour (optional) 
     * @param buttonSuccessTextColour (optional) 
     * @param buttonDangerTextColour (optional) 
     * @param brandPrimaryColour (optional) 
     * @param brandSecondaryColour (optional) 
     * @param brandTertiaryColour (optional) 
     * @param fontHeadingColour (optional) 
     * @param fontBodyColour (optional) 
     * @param isHeaderTextBold (optional) 
     * @param isHeaderTextItalic (optional) 
     * @param isHeaderTextUnderlined (optional) 
     * @return Success
     */
    createNewCompanyBranding(formData: { logo?: FileParameter | null | undefined, favicon?: FileParameter | null | undefined, bodyFont?: FileParameter | null | undefined, headerFont?: FileParameter | null | undefined, companyBrandingFile?: FileParameter | null | undefined, isGeneratedCSSFile?: boolean | undefined, clientPortalName?: string | null | undefined, navbarBackgroundColour?: string | null | undefined, navbarTextColour?: string | null | undefined, navbarButtonColour?: string | null | undefined, navbarButtonTextColour?: string | null | undefined, navbarIconColour?: string | null | undefined, footerBackgroundColour?: string | null | undefined, footerTextColour?: string | null | undefined, footerButtonColour?: string | null | undefined, footerButtonTextColour?: string | null | undefined, toolbarBackgroundColour?: string | null | undefined, toolbarTextColour?: string | null | undefined, toolbarButtonColour?: string | null | undefined, toolbarButtonTextColour?: string | null | undefined, buttonPrimaryColour?: string | null | undefined, buttonSecondaryColour?: string | null | undefined, buttonSuccessColour?: string | null | undefined, buttonDangerColour?: string | null | undefined, buttonPrimaryTextColour?: string | null | undefined, buttonSecondaryTextColour?: string | null | undefined, buttonSuccessTextColour?: string | null | undefined, buttonDangerTextColour?: string | null | undefined, brandPrimaryColour?: string | null | undefined, brandSecondaryColour?: string | null | undefined, brandTertiaryColour?: string | null | undefined, fontHeadingColour?: string | null | undefined, fontBodyColour?: string | null | undefined, isHeaderTextBold?: boolean | undefined, isHeaderTextItalic?: boolean | undefined, isHeaderTextUnderlined?: boolean | undefined }): Promise<void> {
        let url_ = this.baseUrl + "/api/CompanyBranding/CreateNewCompanyBranding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formData.logo !== null && formData.logo !== undefined)
            content_.append("Logo", formData.logo.data, formData.logo.fileName ? formData.logo.fileName : "Logo");
        if (formData.favicon !== null && formData.favicon !== undefined)
            content_.append("Favicon", formData.favicon.data, formData.favicon.fileName ? formData.favicon.fileName : "Favicon");
        if (formData.bodyFont !== null && formData.bodyFont !== undefined)
            content_.append("BodyFont", formData.bodyFont.data, formData.bodyFont.fileName ? formData.bodyFont.fileName : "BodyFont");
        if (formData.headerFont !== null && formData.headerFont !== undefined)
            content_.append("HeaderFont", formData.headerFont.data, formData.headerFont.fileName ? formData.headerFont.fileName : "HeaderFont");
        if (formData.companyBrandingFile !== null && formData.companyBrandingFile !== undefined)
            content_.append("CompanyBrandingFile", formData.companyBrandingFile.data, formData.companyBrandingFile.fileName ? formData.companyBrandingFile.fileName : "CompanyBrandingFile");
        if (formData.isGeneratedCSSFile === null || formData.isGeneratedCSSFile === undefined)
            throw new Error("The parameter 'isGeneratedCSSFile' cannot be null.");
        else
            content_.append("IsGeneratedCSSFile", formData.isGeneratedCSSFile.toString());
        if (formData.clientPortalName !== null && formData.clientPortalName !== undefined)
            content_.append("ClientPortalName", formData.clientPortalName.toString());
        if (formData.navbarBackgroundColour !== null && formData.navbarBackgroundColour !== undefined)
            content_.append("NavbarBackgroundColour", formData.navbarBackgroundColour.toString());
        if (formData.navbarTextColour !== null && formData.navbarTextColour !== undefined)
            content_.append("NavbarTextColour", formData.navbarTextColour.toString());
        if (formData.navbarButtonColour !== null && formData.navbarButtonColour !== undefined)
            content_.append("NavbarButtonColour", formData.navbarButtonColour.toString());
        if (formData.navbarButtonTextColour !== null && formData.navbarButtonTextColour !== undefined)
            content_.append("NavbarButtonTextColour", formData.navbarButtonTextColour.toString());
        if (formData.navbarIconColour !== null && formData.navbarIconColour !== undefined)
            content_.append("NavbarIconColour", formData.navbarIconColour.toString());
        if (formData.footerBackgroundColour !== null && formData.footerBackgroundColour !== undefined)
            content_.append("FooterBackgroundColour", formData.footerBackgroundColour.toString());
        if (formData.footerTextColour !== null && formData.footerTextColour !== undefined)
            content_.append("FooterTextColour", formData.footerTextColour.toString());
        if (formData.footerButtonColour !== null && formData.footerButtonColour !== undefined)
            content_.append("FooterButtonColour", formData.footerButtonColour.toString());
        if (formData.footerButtonTextColour !== null && formData.footerButtonTextColour !== undefined)
            content_.append("FooterButtonTextColour", formData.footerButtonTextColour.toString());
        if (formData.toolbarBackgroundColour !== null && formData.toolbarBackgroundColour !== undefined)
            content_.append("ToolbarBackgroundColour", formData.toolbarBackgroundColour.toString());
        if (formData.toolbarTextColour !== null && formData.toolbarTextColour !== undefined)
            content_.append("ToolbarTextColour", formData.toolbarTextColour.toString());
        if (formData.toolbarButtonColour !== null && formData.toolbarButtonColour !== undefined)
            content_.append("ToolbarButtonColour", formData.toolbarButtonColour.toString());
        if (formData.toolbarButtonTextColour !== null && formData.toolbarButtonTextColour !== undefined)
            content_.append("ToolbarButtonTextColour", formData.toolbarButtonTextColour.toString());
        if (formData.buttonPrimaryColour !== null && formData.buttonPrimaryColour !== undefined)
            content_.append("ButtonPrimaryColour", formData.buttonPrimaryColour.toString());
        if (formData.buttonSecondaryColour !== null && formData.buttonSecondaryColour !== undefined)
            content_.append("ButtonSecondaryColour", formData.buttonSecondaryColour.toString());
        if (formData.buttonSuccessColour !== null && formData.buttonSuccessColour !== undefined)
            content_.append("ButtonSuccessColour", formData.buttonSuccessColour.toString());
        if (formData.buttonDangerColour !== null && formData.buttonDangerColour !== undefined)
            content_.append("ButtonDangerColour", formData.buttonDangerColour.toString());
        if (formData.buttonPrimaryTextColour !== null && formData.buttonPrimaryTextColour !== undefined)
            content_.append("ButtonPrimaryTextColour", formData.buttonPrimaryTextColour.toString());
        if (formData.buttonSecondaryTextColour !== null && formData.buttonSecondaryTextColour !== undefined)
            content_.append("ButtonSecondaryTextColour", formData.buttonSecondaryTextColour.toString());
        if (formData.buttonSuccessTextColour !== null && formData.buttonSuccessTextColour !== undefined)
            content_.append("ButtonSuccessTextColour", formData.buttonSuccessTextColour.toString());
        if (formData.buttonDangerTextColour !== null && formData.buttonDangerTextColour !== undefined)
            content_.append("ButtonDangerTextColour", formData.buttonDangerTextColour.toString());
        if (formData.brandPrimaryColour !== null && formData.brandPrimaryColour !== undefined)
            content_.append("BrandPrimaryColour", formData.brandPrimaryColour.toString());
        if (formData.brandSecondaryColour !== null && formData.brandSecondaryColour !== undefined)
            content_.append("BrandSecondaryColour", formData.brandSecondaryColour.toString());
        if (formData.brandTertiaryColour !== null && formData.brandTertiaryColour !== undefined)
            content_.append("BrandTertiaryColour", formData.brandTertiaryColour.toString());
        if (formData.fontHeadingColour !== null && formData.fontHeadingColour !== undefined)
            content_.append("FontHeadingColour", formData.fontHeadingColour.toString());
        if (formData.fontBodyColour !== null && formData.fontBodyColour !== undefined)
            content_.append("FontBodyColour", formData.fontBodyColour.toString());
        if (formData.isHeaderTextBold === null || formData.isHeaderTextBold === undefined)
            throw new Error("The parameter 'isHeaderTextBold' cannot be null.");
        else
            content_.append("IsHeaderTextBold", formData.isHeaderTextBold.toString());
        if (formData.isHeaderTextItalic === null || formData.isHeaderTextItalic === undefined)
            throw new Error("The parameter 'isHeaderTextItalic' cannot be null.");
        else
            content_.append("IsHeaderTextItalic", formData.isHeaderTextItalic.toString());
        if (formData.isHeaderTextUnderlined === null || formData.isHeaderTextUnderlined === undefined)
            throw new Error("The parameter 'isHeaderTextUnderlined' cannot be null.");
        else
            content_.append("IsHeaderTextUnderlined", formData.isHeaderTextUnderlined.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateNewCompanyBranding(_response);
        });
    }

    protected processCreateNewCompanyBranding(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param companyBrandingID (optional) 
     * @param logo (optional) 
     * @param favicon (optional) 
     * @param bodyFont (optional) 
     * @param headerFont (optional) 
     * @param companyBrandingFile (optional) 
     * @param isGeneratedCSSFile (optional) 
     * @param clientPortalName (optional) 
     * @param navbarBackgroundColour (optional) 
     * @param navbarTextColour (optional) 
     * @param navbarButtonColour (optional) 
     * @param navbarButtonTextColour (optional) 
     * @param navbarIconColour (optional) 
     * @param footerBackgroundColour (optional) 
     * @param footerTextColour (optional) 
     * @param footerButtonColour (optional) 
     * @param footerButtonTextColour (optional) 
     * @param toolbarBackgroundColour (optional) 
     * @param toolbarTextColour (optional) 
     * @param toolbarButtonColour (optional) 
     * @param toolbarButtonTextColour (optional) 
     * @param buttonPrimaryColour (optional) 
     * @param buttonSecondaryColour (optional) 
     * @param buttonSuccessColour (optional) 
     * @param buttonDangerColour (optional) 
     * @param buttonPrimaryTextColour (optional) 
     * @param buttonSecondaryTextColour (optional) 
     * @param buttonSuccessTextColour (optional) 
     * @param buttonDangerTextColour (optional) 
     * @param brandPrimaryColour (optional) 
     * @param brandSecondaryColour (optional) 
     * @param brandTertiaryColour (optional) 
     * @param fontHeadingColour (optional) 
     * @param fontBodyColour (optional) 
     * @param isHeaderTextBold (optional) 
     * @param isHeaderTextItalic (optional) 
     * @param isHeaderTextUnderlined (optional) 
     * @return Success
     */
    updateCompanyBranding(formData: { companyBrandingID?: number | undefined, logo?: FileParameter | null | undefined, favicon?: FileParameter | null | undefined, bodyFont?: FileParameter | null | undefined, headerFont?: FileParameter | null | undefined, companyBrandingFile?: FileParameter | null | undefined, isGeneratedCSSFile?: boolean | undefined, clientPortalName?: string | null | undefined, navbarBackgroundColour?: string | null | undefined, navbarTextColour?: string | null | undefined, navbarButtonColour?: string | null | undefined, navbarButtonTextColour?: string | null | undefined, navbarIconColour?: string | null | undefined, footerBackgroundColour?: string | null | undefined, footerTextColour?: string | null | undefined, footerButtonColour?: string | null | undefined, footerButtonTextColour?: string | null | undefined, toolbarBackgroundColour?: string | null | undefined, toolbarTextColour?: string | null | undefined, toolbarButtonColour?: string | null | undefined, toolbarButtonTextColour?: string | null | undefined, buttonPrimaryColour?: string | null | undefined, buttonSecondaryColour?: string | null | undefined, buttonSuccessColour?: string | null | undefined, buttonDangerColour?: string | null | undefined, buttonPrimaryTextColour?: string | null | undefined, buttonSecondaryTextColour?: string | null | undefined, buttonSuccessTextColour?: string | null | undefined, buttonDangerTextColour?: string | null | undefined, brandPrimaryColour?: string | null | undefined, brandSecondaryColour?: string | null | undefined, brandTertiaryColour?: string | null | undefined, fontHeadingColour?: string | null | undefined, fontBodyColour?: string | null | undefined, isHeaderTextBold?: boolean | undefined, isHeaderTextItalic?: boolean | undefined, isHeaderTextUnderlined?: boolean | undefined }): Promise<void> {
        let url_ = this.baseUrl + "/api/CompanyBranding/UpdateCompanyBranding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formData.companyBrandingID === null || formData.companyBrandingID === undefined)
            throw new Error("The parameter 'companyBrandingID' cannot be null.");
        else
            content_.append("CompanyBrandingID", formData.companyBrandingID.toString());
        if (formData.logo !== null && formData.logo !== undefined)
            content_.append("Logo", formData.logo.data, formData.logo.fileName ? formData.logo.fileName : "Logo");
        if (formData.favicon !== null && formData.favicon !== undefined)
            content_.append("Favicon", formData.favicon.data, formData.favicon.fileName ? formData.favicon.fileName : "Favicon");
        if (formData.bodyFont !== null && formData.bodyFont !== undefined)
            content_.append("BodyFont", formData.bodyFont.data, formData.bodyFont.fileName ? formData.bodyFont.fileName : "BodyFont");
        if (formData.headerFont !== null && formData.headerFont !== undefined)
            content_.append("HeaderFont", formData.headerFont.data, formData.headerFont.fileName ? formData.headerFont.fileName : "HeaderFont");
        if (formData.companyBrandingFile !== null && formData.companyBrandingFile !== undefined)
            content_.append("CompanyBrandingFile", formData.companyBrandingFile.data, formData.companyBrandingFile.fileName ? formData.companyBrandingFile.fileName : "CompanyBrandingFile");
        if (formData.isGeneratedCSSFile === null || formData.isGeneratedCSSFile === undefined)
            throw new Error("The parameter 'isGeneratedCSSFile' cannot be null.");
        else
            content_.append("IsGeneratedCSSFile", formData.isGeneratedCSSFile.toString());
        if (formData.clientPortalName !== null && formData.clientPortalName !== undefined)
            content_.append("ClientPortalName", formData.clientPortalName.toString());
        if (formData.navbarBackgroundColour !== null && formData.navbarBackgroundColour !== undefined)
            content_.append("NavbarBackgroundColour", formData.navbarBackgroundColour.toString());
        if (formData.navbarTextColour !== null && formData.navbarTextColour !== undefined)
            content_.append("NavbarTextColour", formData.navbarTextColour.toString());
        if (formData.navbarButtonColour !== null && formData.navbarButtonColour !== undefined)
            content_.append("NavbarButtonColour", formData.navbarButtonColour.toString());
        if (formData.navbarButtonTextColour !== null && formData.navbarButtonTextColour !== undefined)
            content_.append("NavbarButtonTextColour", formData.navbarButtonTextColour.toString());
        if (formData.navbarIconColour !== null && formData.navbarIconColour !== undefined)
            content_.append("NavbarIconColour", formData.navbarIconColour.toString());
        if (formData.footerBackgroundColour !== null && formData.footerBackgroundColour !== undefined)
            content_.append("FooterBackgroundColour", formData.footerBackgroundColour.toString());
        if (formData.footerTextColour !== null && formData.footerTextColour !== undefined)
            content_.append("FooterTextColour", formData.footerTextColour.toString());
        if (formData.footerButtonColour !== null && formData.footerButtonColour !== undefined)
            content_.append("FooterButtonColour", formData.footerButtonColour.toString());
        if (formData.footerButtonTextColour !== null && formData.footerButtonTextColour !== undefined)
            content_.append("FooterButtonTextColour", formData.footerButtonTextColour.toString());
        if (formData.toolbarBackgroundColour !== null && formData.toolbarBackgroundColour !== undefined)
            content_.append("ToolbarBackgroundColour", formData.toolbarBackgroundColour.toString());
        if (formData.toolbarTextColour !== null && formData.toolbarTextColour !== undefined)
            content_.append("ToolbarTextColour", formData.toolbarTextColour.toString());
        if (formData.toolbarButtonColour !== null && formData.toolbarButtonColour !== undefined)
            content_.append("ToolbarButtonColour", formData.toolbarButtonColour.toString());
        if (formData.toolbarButtonTextColour !== null && formData.toolbarButtonTextColour !== undefined)
            content_.append("ToolbarButtonTextColour", formData.toolbarButtonTextColour.toString());
        if (formData.buttonPrimaryColour !== null && formData.buttonPrimaryColour !== undefined)
            content_.append("ButtonPrimaryColour", formData.buttonPrimaryColour.toString());
        if (formData.buttonSecondaryColour !== null && formData.buttonSecondaryColour !== undefined)
            content_.append("ButtonSecondaryColour", formData.buttonSecondaryColour.toString());
        if (formData.buttonSuccessColour !== null && formData.buttonSuccessColour !== undefined)
            content_.append("ButtonSuccessColour", formData.buttonSuccessColour.toString());
        if (formData.buttonDangerColour !== null && formData.buttonDangerColour !== undefined)
            content_.append("ButtonDangerColour", formData.buttonDangerColour.toString());
        if (formData.buttonPrimaryTextColour !== null && formData.buttonPrimaryTextColour !== undefined)
            content_.append("ButtonPrimaryTextColour", formData.buttonPrimaryTextColour.toString());
        if (formData.buttonSecondaryTextColour !== null && formData.buttonSecondaryTextColour !== undefined)
            content_.append("ButtonSecondaryTextColour", formData.buttonSecondaryTextColour.toString());
        if (formData.buttonSuccessTextColour !== null && formData.buttonSuccessTextColour !== undefined)
            content_.append("ButtonSuccessTextColour", formData.buttonSuccessTextColour.toString());
        if (formData.buttonDangerTextColour !== null && formData.buttonDangerTextColour !== undefined)
            content_.append("ButtonDangerTextColour", formData.buttonDangerTextColour.toString());
        if (formData.brandPrimaryColour !== null && formData.brandPrimaryColour !== undefined)
            content_.append("BrandPrimaryColour", formData.brandPrimaryColour.toString());
        if (formData.brandSecondaryColour !== null && formData.brandSecondaryColour !== undefined)
            content_.append("BrandSecondaryColour", formData.brandSecondaryColour.toString());
        if (formData.brandTertiaryColour !== null && formData.brandTertiaryColour !== undefined)
            content_.append("BrandTertiaryColour", formData.brandTertiaryColour.toString());
        if (formData.fontHeadingColour !== null && formData.fontHeadingColour !== undefined)
            content_.append("FontHeadingColour", formData.fontHeadingColour.toString());
        if (formData.fontBodyColour !== null && formData.fontBodyColour !== undefined)
            content_.append("FontBodyColour", formData.fontBodyColour.toString());
        if (formData.isHeaderTextBold === null || formData.isHeaderTextBold === undefined)
            throw new Error("The parameter 'isHeaderTextBold' cannot be null.");
        else
            content_.append("IsHeaderTextBold", formData.isHeaderTextBold.toString());
        if (formData.isHeaderTextItalic === null || formData.isHeaderTextItalic === undefined)
            throw new Error("The parameter 'isHeaderTextItalic' cannot be null.");
        else
            content_.append("IsHeaderTextItalic", formData.isHeaderTextItalic.toString());
        if (formData.isHeaderTextUnderlined === null || formData.isHeaderTextUnderlined === undefined)
            throw new Error("The parameter 'isHeaderTextUnderlined' cannot be null.");
        else
            content_.append("IsHeaderTextUnderlined", formData.isHeaderTextUnderlined.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCompanyBranding(_response);
        });
    }

    protected processUpdateCompanyBranding(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param companyID (optional) 
     * @return Success
     */
    getCompanyBrandingCSSFileURL(companyID?: string | undefined): Promise<CompanyBrandingUrlModel> {
        let url_ = this.baseUrl + "/api/CompanyBranding/GetCompanyBrandingCSSFileURL?";
        if (companyID === null)
            throw new globalThis.Error("The parameter 'companyID' cannot be null.");
        else if (companyID !== undefined)
            url_ += "companyID=" + encodeURIComponent("" + companyID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyBrandingCSSFileURL(_response);
        });
    }

    protected processGetCompanyBrandingCSSFileURL(response: Response): Promise<CompanyBrandingUrlModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyBrandingUrlModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<CompanyBrandingUrlModel>(null as any);
    }

    /**
     * @return Success
     */
    getCompanyLoginScreenNarrative(): Promise<LoginScreenNarrativeModel> {
        let url_ = this.baseUrl + "/api/CompanyBranding/GetCompanyLoginScreenNarrative";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyLoginScreenNarrative(_response);
        });
    }

    protected processGetCompanyLoginScreenNarrative(response: Response): Promise<LoginScreenNarrativeModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginScreenNarrativeModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<LoginScreenNarrativeModel>(null as any);
    }

    /**
     * @param companyID (optional) 
     * @return Success
     */
    getCompanyLoginScreenNarrativeForCompany(companyID?: string | undefined): Promise<LoginScreenNarrativeModel> {
        let url_ = this.baseUrl + "/api/CompanyBranding/GetCompanyLoginScreenNarrativeForCompany?";
        if (companyID === null)
            throw new globalThis.Error("The parameter 'companyID' cannot be null.");
        else if (companyID !== undefined)
            url_ += "companyID=" + encodeURIComponent("" + companyID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyLoginScreenNarrativeForCompany(_response);
        });
    }

    protected processGetCompanyLoginScreenNarrativeForCompany(response: Response): Promise<LoginScreenNarrativeModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginScreenNarrativeModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<LoginScreenNarrativeModel>(null as any);
    }

    /**
     * @param loginScreenNarrative (optional) 
     * @return Success
     */
    createNewCompanyLoginScreenNarrative(loginScreenNarrative?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CompanyBranding/CreateNewCompanyLoginScreenNarrative?";
        if (loginScreenNarrative === null)
            throw new globalThis.Error("The parameter 'loginScreenNarrative' cannot be null.");
        else if (loginScreenNarrative !== undefined)
            url_ += "loginScreenNarrative=" + encodeURIComponent("" + loginScreenNarrative) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateNewCompanyLoginScreenNarrative(_response);
        });
    }

    protected processCreateNewCompanyLoginScreenNarrative(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCompanyLoginScreenNarrative(body?: LoginScreenNarrativeModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CompanyBranding/UpdateCompanyLoginScreenNarrative";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCompanyLoginScreenNarrative(_response);
        });
    }

    protected processUpdateCompanyLoginScreenNarrative(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICPLAuthGoCardlessClient {

    /**
     * @return Success
     */
    handleWebhook(): Promise<void>;

    /**
     * @return Success
     */
    authoriseMerchant(): Promise<AuthoriseMerchantResponseModel>;

    /**
     * @return Success
     */
    revokeAccessToken(): Promise<void>;

    /**
     * @param code (optional) 
     * @param state (optional) 
     * @return Success
     */
    getAccessToken(code?: string | undefined, state?: string | undefined): Promise<void>;
}

@injectable()
export class CPLAuthGoCardlessClient extends CPLAuthClientBase implements ICPLAuthGoCardlessClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    handleWebhook(): Promise<void> {
        let url_ = this.baseUrl + "/api/GoCardless/HandleWebhook";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHandleWebhook(_response);
        });
    }

    protected processHandleWebhook(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    authoriseMerchant(): Promise<AuthoriseMerchantResponseModel> {
        let url_ = this.baseUrl + "/api/GoCardless/AuthoriseMerchant";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAuthoriseMerchant(_response);
        });
    }

    protected processAuthoriseMerchant(response: Response): Promise<AuthoriseMerchantResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthoriseMerchantResponseModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<AuthoriseMerchantResponseModel>(null as any);
    }

    /**
     * @return Success
     */
    revokeAccessToken(): Promise<void> {
        let url_ = this.baseUrl + "/api/GoCardless/RevokeAccessToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRevokeAccessToken(_response);
        });
    }

    protected processRevokeAccessToken(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param code (optional) 
     * @param state (optional) 
     * @return Success
     */
    getAccessToken(code?: string | undefined, state?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/GoCardless/GetAccessToken?";
        if (code === null)
            throw new globalThis.Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (state === null)
            throw new globalThis.Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAccessToken(_response);
        });
    }

    protected processGetAccessToken(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICPLAuthImpersonationClient {

    /**
     * @param clientPortalUserId (optional) 
     * @return Success
     */
    getImpersonationToken(clientPortalUserId?: string | undefined): Promise<ImpersonationHandoffModel>;

    /**
     * @param reference (optional) 
     * @return Success
     */
    redeemImpersonationHandoff(reference?: string | undefined): Promise<ImpersonationTokenModel>;
}

@injectable()
export class CPLAuthImpersonationClient extends CPLAuthClientBase implements ICPLAuthImpersonationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param clientPortalUserId (optional) 
     * @return Success
     */
    getImpersonationToken(clientPortalUserId?: string | undefined): Promise<ImpersonationHandoffModel> {
        let url_ = this.baseUrl + "/api/Impersonation/GetImpersonationToken?";
        if (clientPortalUserId === null)
            throw new globalThis.Error("The parameter 'clientPortalUserId' cannot be null.");
        else if (clientPortalUserId !== undefined)
            url_ += "clientPortalUserId=" + encodeURIComponent("" + clientPortalUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetImpersonationToken(_response);
        });
    }

    protected processGetImpersonationToken(response: Response): Promise<ImpersonationHandoffModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonationHandoffModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ImpersonationHandoffModel>(null as any);
    }

    /**
     * @param reference (optional) 
     * @return Success
     */
    redeemImpersonationHandoff(reference?: string | undefined): Promise<ImpersonationTokenModel> {
        let url_ = this.baseUrl + "/api/Impersonation/RedeemImpersonationHandoff?";
        if (reference === null)
            throw new globalThis.Error("The parameter 'reference' cannot be null.");
        else if (reference !== undefined)
            url_ += "reference=" + encodeURIComponent("" + reference) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRedeemImpersonationHandoff(_response);
        });
    }

    protected processRedeemImpersonationHandoff(response: Response): Promise<ImpersonationTokenModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonationTokenModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<ImpersonationTokenModel>(null as any);
    }
}

export interface ICPLAuthLicenceClient {

    /**
     * @return Success
     */
    runLicenceCheck(): Promise<void>;

    /**
     * @return Success
     */
    getLicenceStatus(): Promise<CompanyLicenceModel>;
}

@injectable()
export class CPLAuthLicenceClient extends CPLAuthClientBase implements ICPLAuthLicenceClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    runLicenceCheck(): Promise<void> {
        let url_ = this.baseUrl + "/api/Licence/RunLicenceCheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRunLicenceCheck(_response);
        });
    }

    protected processRunLicenceCheck(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getLicenceStatus(): Promise<CompanyLicenceModel> {
        let url_ = this.baseUrl + "/api/Licence/GetLicenceStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLicenceStatus(_response);
        });
    }

    protected processGetLicenceStatus(response: Response): Promise<CompanyLicenceModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyLicenceModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<CompanyLicenceModel>(null as any);
    }
}

export interface ICPLAuthLinkGenerationClient {

    /**
     * @return Success
     */
    getCPLConnectLoginLink(): Promise<string>;

    /**
     * @param redirectPath (optional) 
     * @param accessDataJson (optional) 
     * @return Success
     */
    getCPLConnectExternalAccessLink(redirectPath?: string | undefined, accessDataJson?: string | undefined): Promise<string>;
}

@injectable()
export class CPLAuthLinkGenerationClient extends CPLAuthClientBase implements ICPLAuthLinkGenerationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getCPLConnectLoginLink(): Promise<string> {
        let url_ = this.baseUrl + "/api/LinkGeneration/GetCPLConnectLoginLink";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCPLConnectLoginLink(_response);
        });
    }

    protected processGetCPLConnectLoginLink(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param redirectPath (optional) 
     * @param accessDataJson (optional) 
     * @return Success
     */
    getCPLConnectExternalAccessLink(redirectPath?: string | undefined, accessDataJson?: string | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/LinkGeneration/GetCPLConnectExternalAccessLink?";
        if (redirectPath === null)
            throw new globalThis.Error("The parameter 'redirectPath' cannot be null.");
        else if (redirectPath !== undefined)
            url_ += "redirectPath=" + encodeURIComponent("" + redirectPath) + "&";
        if (accessDataJson === null)
            throw new globalThis.Error("The parameter 'accessDataJson' cannot be null.");
        else if (accessDataJson !== undefined)
            url_ += "accessDataJson=" + encodeURIComponent("" + accessDataJson) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCPLConnectExternalAccessLink(_response);
        });
    }

    protected processGetCPLConnectExternalAccessLink(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface ICPLAuthMaintenanceClient {

    /**
     * @return Success
     */
    getMaintenanceDates(): Promise<CPLMaintenanceDatesModel>;

    /**
     * @return Success
     */
    checkMaintenanceDates(): Promise<void>;
}

@injectable()
export class CPLAuthMaintenanceClient extends CPLAuthClientBase implements ICPLAuthMaintenanceClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getMaintenanceDates(): Promise<CPLMaintenanceDatesModel> {
        let url_ = this.baseUrl + "/api/Maintenance/GetMaintenanceDates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMaintenanceDates(_response);
        });
    }

    protected processGetMaintenanceDates(response: Response): Promise<CPLMaintenanceDatesModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CPLMaintenanceDatesModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<CPLMaintenanceDatesModel>(null as any);
    }

    /**
     * @return Success
     */
    checkMaintenanceDates(): Promise<void> {
        let url_ = this.baseUrl + "/api/Maintenance/CheckMaintenanceDates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckMaintenanceDates(_response);
        });
    }

    protected processCheckMaintenanceDates(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICPLAuthPermissionsClient {

    /**
     * @param userID (optional) 
     * @param permissionID (optional) 
     * @return Success
     */
    grantUserPermissionAssignment(userID?: string | undefined, permissionID?: number | undefined): Promise<void>;

    /**
     * @param userID (optional) 
     * @param permissionID (optional) 
     * @return Success
     */
    denyUserPermissionAssignment(userID?: string | undefined, permissionID?: number | undefined): Promise<void>;

    /**
     * @param userGroupID (optional) 
     * @param permissionID (optional) 
     * @return Success
     */
    grantUserGroupPermissionAssignment(userGroupID?: number | undefined, permissionID?: number | undefined): Promise<void>;

    /**
     * @param userGroupID (optional) 
     * @param permissionID (optional) 
     * @return Success
     */
    denyUserGroupPermissionAssignment(userGroupID?: number | undefined, permissionID?: number | undefined): Promise<void>;

    /**
     * @param permissionAssignmentID (optional) 
     * @return Success
     */
    deletePermissionAssignment(permissionAssignmentID?: number | undefined): Promise<void>;

    /**
     * @return Success
     */
    getAllPermissionCategories(): Promise<PermissionCategoryModel[]>;

    /**
     * @param permissionCategoryID (optional) 
     * @return Success
     */
    getAllPermissionsForCategory(permissionCategoryID?: number | undefined): Promise<PermissionModel[]>;

    /**
     * @param permissionCategoryID (optional) 
     * @return Success
     */
    getPermissionAssignmentsMatrix(permissionCategoryID?: number | undefined): Promise<PermissionManagementMatrixModel>;

    /**
     * @param userID (optional) 
     * @return Success
     */
    getAllPermissionsForUser(userID?: string | undefined): Promise<UserPermissionModel[]>;
}

@injectable()
export class CPLAuthPermissionsClient extends CPLAuthClientBase implements ICPLAuthPermissionsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param userID (optional) 
     * @param permissionID (optional) 
     * @return Success
     */
    grantUserPermissionAssignment(userID?: string | undefined, permissionID?: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Permissions/GrantUserPermissionAssignment?";
        if (userID === null)
            throw new globalThis.Error("The parameter 'userID' cannot be null.");
        else if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&";
        if (permissionID === null)
            throw new globalThis.Error("The parameter 'permissionID' cannot be null.");
        else if (permissionID !== undefined)
            url_ += "permissionID=" + encodeURIComponent("" + permissionID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGrantUserPermissionAssignment(_response);
        });
    }

    protected processGrantUserPermissionAssignment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userID (optional) 
     * @param permissionID (optional) 
     * @return Success
     */
    denyUserPermissionAssignment(userID?: string | undefined, permissionID?: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Permissions/DenyUserPermissionAssignment?";
        if (userID === null)
            throw new globalThis.Error("The parameter 'userID' cannot be null.");
        else if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&";
        if (permissionID === null)
            throw new globalThis.Error("The parameter 'permissionID' cannot be null.");
        else if (permissionID !== undefined)
            url_ += "permissionID=" + encodeURIComponent("" + permissionID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDenyUserPermissionAssignment(_response);
        });
    }

    protected processDenyUserPermissionAssignment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userGroupID (optional) 
     * @param permissionID (optional) 
     * @return Success
     */
    grantUserGroupPermissionAssignment(userGroupID?: number | undefined, permissionID?: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Permissions/GrantUserGroupPermissionAssignment?";
        if (userGroupID === null)
            throw new globalThis.Error("The parameter 'userGroupID' cannot be null.");
        else if (userGroupID !== undefined)
            url_ += "userGroupID=" + encodeURIComponent("" + userGroupID) + "&";
        if (permissionID === null)
            throw new globalThis.Error("The parameter 'permissionID' cannot be null.");
        else if (permissionID !== undefined)
            url_ += "permissionID=" + encodeURIComponent("" + permissionID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGrantUserGroupPermissionAssignment(_response);
        });
    }

    protected processGrantUserGroupPermissionAssignment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userGroupID (optional) 
     * @param permissionID (optional) 
     * @return Success
     */
    denyUserGroupPermissionAssignment(userGroupID?: number | undefined, permissionID?: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Permissions/DenyUserGroupPermissionAssignment?";
        if (userGroupID === null)
            throw new globalThis.Error("The parameter 'userGroupID' cannot be null.");
        else if (userGroupID !== undefined)
            url_ += "userGroupID=" + encodeURIComponent("" + userGroupID) + "&";
        if (permissionID === null)
            throw new globalThis.Error("The parameter 'permissionID' cannot be null.");
        else if (permissionID !== undefined)
            url_ += "permissionID=" + encodeURIComponent("" + permissionID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDenyUserGroupPermissionAssignment(_response);
        });
    }

    protected processDenyUserGroupPermissionAssignment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param permissionAssignmentID (optional) 
     * @return Success
     */
    deletePermissionAssignment(permissionAssignmentID?: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Permissions/DeletePermissionAssignment?";
        if (permissionAssignmentID === null)
            throw new globalThis.Error("The parameter 'permissionAssignmentID' cannot be null.");
        else if (permissionAssignmentID !== undefined)
            url_ += "permissionAssignmentID=" + encodeURIComponent("" + permissionAssignmentID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeletePermissionAssignment(_response);
        });
    }

    protected processDeletePermissionAssignment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllPermissionCategories(): Promise<PermissionCategoryModel[]> {
        let url_ = this.baseUrl + "/api/Permissions/GetAllPermissionCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllPermissionCategories(_response);
        });
    }

    protected processGetAllPermissionCategories(response: Response): Promise<PermissionCategoryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PermissionCategoryModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<PermissionCategoryModel[]>(null as any);
    }

    /**
     * @param permissionCategoryID (optional) 
     * @return Success
     */
    getAllPermissionsForCategory(permissionCategoryID?: number | undefined): Promise<PermissionModel[]> {
        let url_ = this.baseUrl + "/api/Permissions/GetAllPermissionsForCategory?";
        if (permissionCategoryID === null)
            throw new globalThis.Error("The parameter 'permissionCategoryID' cannot be null.");
        else if (permissionCategoryID !== undefined)
            url_ += "permissionCategoryID=" + encodeURIComponent("" + permissionCategoryID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllPermissionsForCategory(_response);
        });
    }

    protected processGetAllPermissionsForCategory(response: Response): Promise<PermissionModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PermissionModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<PermissionModel[]>(null as any);
    }

    /**
     * @param permissionCategoryID (optional) 
     * @return Success
     */
    getPermissionAssignmentsMatrix(permissionCategoryID?: number | undefined): Promise<PermissionManagementMatrixModel> {
        let url_ = this.baseUrl + "/api/Permissions/GetPermissionAssignmentsMatrix?";
        if (permissionCategoryID === null)
            throw new globalThis.Error("The parameter 'permissionCategoryID' cannot be null.");
        else if (permissionCategoryID !== undefined)
            url_ += "permissionCategoryID=" + encodeURIComponent("" + permissionCategoryID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPermissionAssignmentsMatrix(_response);
        });
    }

    protected processGetPermissionAssignmentsMatrix(response: Response): Promise<PermissionManagementMatrixModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PermissionManagementMatrixModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<PermissionManagementMatrixModel>(null as any);
    }

    /**
     * @param userID (optional) 
     * @return Success
     */
    getAllPermissionsForUser(userID?: string | undefined): Promise<UserPermissionModel[]> {
        let url_ = this.baseUrl + "/api/Permissions/GetAllPermissionsForUser?";
        if (userID === null)
            throw new globalThis.Error("The parameter 'userID' cannot be null.");
        else if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllPermissionsForUser(_response);
        });
    }

    protected processGetAllPermissionsForUser(response: Response): Promise<UserPermissionModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserPermissionModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<UserPermissionModel[]>(null as any);
    }
}

export interface ICPLAuthSingleUseTokensClient {

    /**
     * @param singleUseToken (optional) 
     * @return Success
     */
    validateSingleUseToken(singleUseToken?: string | undefined): Promise<boolean>;

    /**
     * @param singleUseToken (optional) 
     * @return Success
     */
    deleteSingleUseToken(singleUseToken?: string | undefined): Promise<void>;
}

@injectable()
export class CPLAuthSingleUseTokensClient extends CPLAuthClientBase implements ICPLAuthSingleUseTokensClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @param singleUseToken (optional) 
     * @return Success
     */
    validateSingleUseToken(singleUseToken?: string | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SingleUseTokens/ValidateSingleUseToken?";
        if (singleUseToken === null)
            throw new globalThis.Error("The parameter 'singleUseToken' cannot be null.");
        else if (singleUseToken !== undefined)
            url_ += "singleUseToken=" + encodeURIComponent("" + singleUseToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValidateSingleUseToken(_response);
        });
    }

    protected processValidateSingleUseToken(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param singleUseToken (optional) 
     * @return Success
     */
    deleteSingleUseToken(singleUseToken?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/SingleUseTokens/DeleteSingleUseToken?";
        if (singleUseToken === null)
            throw new globalThis.Error("The parameter 'singleUseToken' cannot be null.");
        else if (singleUseToken !== undefined)
            url_ += "singleUseToken=" + encodeURIComponent("" + singleUseToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteSingleUseToken(_response);
        });
    }

    protected processDeleteSingleUseToken(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICPLAuthTestClient {

    /**
     * @return Success
     */
    sendTestEmail(): Promise<string>;

    /**
     * @return Success
     */
    sendAllTestEmails(): Promise<void>;

    /**
     * @param userID (optional) 
     * @param notificationType (optional) 
     * @param notificationStyle (optional) 
     * @return Success
     */
    testSignalRNotification(userID?: string | undefined, notificationType?: NotificationTypes | undefined, notificationStyle?: NotificationStyles | undefined): Promise<void>;
}

@injectable()
export class CPLAuthTestClient extends CPLAuthClientBase implements ICPLAuthTestClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    sendTestEmail(): Promise<string> {
        let url_ = this.baseUrl + "/api/Test/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendTestEmail(_response);
        });
    }

    protected processSendTestEmail(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    sendAllTestEmails(): Promise<void> {
        let url_ = this.baseUrl + "/api/Test/SendAllTestEmails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendAllTestEmails(_response);
        });
    }

    protected processSendAllTestEmails(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userID (optional) 
     * @param notificationType (optional) 
     * @param notificationStyle (optional) 
     * @return Success
     */
    testSignalRNotification(userID?: string | undefined, notificationType?: NotificationTypes | undefined, notificationStyle?: NotificationStyles | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Test/TestSignalRNotification?";
        if (userID === null)
            throw new globalThis.Error("The parameter 'userID' cannot be null.");
        else if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&";
        if (notificationType === null)
            throw new globalThis.Error("The parameter 'notificationType' cannot be null.");
        else if (notificationType !== undefined)
            url_ += "notificationType=" + encodeURIComponent("" + notificationType) + "&";
        if (notificationStyle === null)
            throw new globalThis.Error("The parameter 'notificationStyle' cannot be null.");
        else if (notificationStyle !== undefined)
            url_ += "notificationStyle=" + encodeURIComponent("" + notificationStyle) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTestSignalRNotification(_response);
        });
    }

    protected processTestSignalRNotification(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICPLAuthUserGroupClient {

    /**
     * @return Success
     */
    getAllUserGroups(): Promise<UserGroupModel[]>;

    /**
     * @param userGroupID (optional) 
     * @return Success
     */
    getUserGroup(userGroupID?: number | undefined): Promise<UserGroupModel>;

    /**
     * @param groupName (optional) 
     * @return Success
     */
    createUserGroup(groupName?: string | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserGroup(body?: UserGroupModel | undefined): Promise<void>;

    /**
     * @param userGroupID (optional) 
     * @return Success
     */
    deleteUserGroup(userGroupID?: number | undefined): Promise<void>;

    /**
     * @param userGroupID (optional) 
     * @return Success
     */
    getUserGroupMembers(userGroupID?: number | undefined): Promise<UserModel[]>;

    /**
     * @param userID (optional) 
     * @param userGroupID (optional) 
     * @return Success
     */
    addUserToGroup(userID?: string | undefined, userGroupID?: number | undefined): Promise<void>;

    /**
     * @param userID (optional) 
     * @param userGroupID (optional) 
     * @return Success
     */
    deleteUserFromGroup(userID?: string | undefined, userGroupID?: number | undefined): Promise<void>;
}

@injectable()
export class CPLAuthUserGroupClient extends CPLAuthClientBase implements ICPLAuthUserGroupClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getAllUserGroups(): Promise<UserGroupModel[]> {
        let url_ = this.baseUrl + "/api/UserGroup/GetAllUserGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllUserGroups(_response);
        });
    }

    protected processGetAllUserGroups(response: Response): Promise<UserGroupModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserGroupModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<UserGroupModel[]>(null as any);
    }

    /**
     * @param userGroupID (optional) 
     * @return Success
     */
    getUserGroup(userGroupID?: number | undefined): Promise<UserGroupModel> {
        let url_ = this.baseUrl + "/api/UserGroup/GetUserGroup?";
        if (userGroupID === null)
            throw new globalThis.Error("The parameter 'userGroupID' cannot be null.");
        else if (userGroupID !== undefined)
            url_ += "userGroupID=" + encodeURIComponent("" + userGroupID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserGroup(_response);
        });
    }

    protected processGetUserGroup(response: Response): Promise<UserGroupModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserGroupModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<UserGroupModel>(null as any);
    }

    /**
     * @param groupName (optional) 
     * @return Success
     */
    createUserGroup(groupName?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UserGroup/CreateUserGroup?";
        if (groupName === null)
            throw new globalThis.Error("The parameter 'groupName' cannot be null.");
        else if (groupName !== undefined)
            url_ += "groupName=" + encodeURIComponent("" + groupName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateUserGroup(_response);
        });
    }

    protected processCreateUserGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserGroup(body?: UserGroupModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UserGroup/UpdateUserGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUserGroup(_response);
        });
    }

    protected processUpdateUserGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userGroupID (optional) 
     * @return Success
     */
    deleteUserGroup(userGroupID?: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UserGroup/DeleteUserGroup?";
        if (userGroupID === null)
            throw new globalThis.Error("The parameter 'userGroupID' cannot be null.");
        else if (userGroupID !== undefined)
            url_ += "userGroupID=" + encodeURIComponent("" + userGroupID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteUserGroup(_response);
        });
    }

    protected processDeleteUserGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userGroupID (optional) 
     * @return Success
     */
    getUserGroupMembers(userGroupID?: number | undefined): Promise<UserModel[]> {
        let url_ = this.baseUrl + "/api/UserGroup/GetUserGroupMembers?";
        if (userGroupID === null)
            throw new globalThis.Error("The parameter 'userGroupID' cannot be null.");
        else if (userGroupID !== undefined)
            url_ += "userGroupID=" + encodeURIComponent("" + userGroupID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserGroupMembers(_response);
        });
    }

    protected processGetUserGroupMembers(response: Response): Promise<UserModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<UserModel[]>(null as any);
    }

    /**
     * @param userID (optional) 
     * @param userGroupID (optional) 
     * @return Success
     */
    addUserToGroup(userID?: string | undefined, userGroupID?: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UserGroup/AddUserToGroup?";
        if (userID === null)
            throw new globalThis.Error("The parameter 'userID' cannot be null.");
        else if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&";
        if (userGroupID === null)
            throw new globalThis.Error("The parameter 'userGroupID' cannot be null.");
        else if (userGroupID !== undefined)
            url_ += "userGroupID=" + encodeURIComponent("" + userGroupID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddUserToGroup(_response);
        });
    }

    protected processAddUserToGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userID (optional) 
     * @param userGroupID (optional) 
     * @return Success
     */
    deleteUserFromGroup(userID?: string | undefined, userGroupID?: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UserGroup/DeleteUserFromGroup?";
        if (userID === null)
            throw new globalThis.Error("The parameter 'userID' cannot be null.");
        else if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&";
        if (userGroupID === null)
            throw new globalThis.Error("The parameter 'userGroupID' cannot be null.");
        else if (userGroupID !== undefined)
            url_ += "userGroupID=" + encodeURIComponent("" + userGroupID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteUserFromGroup(_response);
        });
    }

    protected processDeleteUserFromGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICPLAuthUserMigrationClient {

    /**
     * @return Success
     */
    migrateAllCoreAccounts(): Promise<string[]>;

    /**
     * @return Success
     */
    resendUserInvitiations(): Promise<void>;
}

@injectable()
export class CPLAuthUserMigrationClient extends CPLAuthClientBase implements ICPLAuthUserMigrationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    migrateAllCoreAccounts(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/UserMigration/MigrateAllCoreAccounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMigrateAllCoreAccounts(_response);
        });
    }

    protected processMigrateAllCoreAccounts(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @return Success
     */
    resendUserInvitiations(): Promise<void> {
        let url_ = this.baseUrl + "/api/UserMigration/ResendUserInvitiations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResendUserInvitiations(_response);
        });
    }

    protected processResendUserInvitiations(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICPLAuthUsersClient {

    /**
     * @return Success
     */
    getProfile(): Promise<UserModel>;

    /**
     * @param userID (optional) 
     * @return Success
     */
    getUser(userID?: string | undefined): Promise<UserModel>;

    /**
     * @param includeInactive (optional) 
     * @return Success
     */
    getAllUsers(includeInactive?: boolean | undefined): Promise<UserModel[]>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUser(body?: UserModel | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    createNewUser(body?: NewUserModel | undefined): Promise<void>;

    /**
     * @param newPassword (optional) 
     * @return Success
     */
    changeProfilePassword(newPassword?: string | undefined): Promise<void>;

    /**
     * @param userID (optional) 
     * @param newPassword (optional) 
     * @return Success
     */
    changeUserPassword(userID?: string | undefined, newPassword?: string | undefined): Promise<void>;

    /**
     * @param userID (optional) 
     * @param verificationCode (optional) 
     * @return Success
     */
    verifyEmail(userID?: string | undefined, verificationCode?: string | undefined): Promise<void>;

    /**
     * @param userID (optional) 
     * @return Success
     */
    resendVerificationCode(userID?: string | undefined): Promise<void>;

    /**
     * @param userID (optional) 
     * @return Success
     */
    updateUserActiveStatus(userID?: string | undefined): Promise<void>;

    /**
     * @param emailAddress (optional) 
     * @return Success
     */
    passwordReset(emailAddress?: string | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    externalPasswordChange(body?: ExternalPasswordChangeModel | undefined): Promise<void>;

    /**
     * @param rpmUserID (optional) 
     * @return Success
     */
    setRPMUserID(rpmUserID?: string | undefined): Promise<void>;

    /**
     * @param body (optional) 
     * @return Success
     */
    migrateCoreAccount(body?: CoreMigrationRequestModel | undefined): Promise<boolean>;
}

@injectable()
export class CPLAuthUsersClient extends CPLAuthClientBase implements ICPLAuthUsersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.http = window as any;
        this.baseUrl = this.getBaseUrl("", undefined);
    }

    /**
     * @return Success
     */
    getProfile(): Promise<UserModel> {
        let url_ = this.baseUrl + "/api/Users/GetProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProfile(_response);
        });
    }

    protected processGetProfile(response: Response): Promise<UserModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<UserModel>(null as any);
    }

    /**
     * @param userID (optional) 
     * @return Success
     */
    getUser(userID?: string | undefined): Promise<UserModel> {
        let url_ = this.baseUrl + "/api/Users/GetUser?";
        if (userID === null)
            throw new globalThis.Error("The parameter 'userID' cannot be null.");
        else if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: Response): Promise<UserModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<UserModel>(null as any);
    }

    /**
     * @param includeInactive (optional) 
     * @return Success
     */
    getAllUsers(includeInactive?: boolean | undefined): Promise<UserModel[]> {
        let url_ = this.baseUrl + "/api/Users/GetAllUsers?";
        if (includeInactive === null)
            throw new globalThis.Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllUsers(_response);
        });
    }

    protected processGetAllUsers(response: Response): Promise<UserModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<UserModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUser(body?: UserModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/UpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createNewUser(body?: NewUserModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/CreateNewUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateNewUser(_response);
        });
    }

    protected processCreateNewUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param newPassword (optional) 
     * @return Success
     */
    changeProfilePassword(newPassword?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/ChangeProfilePassword?";
        if (newPassword === null)
            throw new globalThis.Error("The parameter 'newPassword' cannot be null.");
        else if (newPassword !== undefined)
            url_ += "newPassword=" + encodeURIComponent("" + newPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangeProfilePassword(_response);
        });
    }

    protected processChangeProfilePassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userID (optional) 
     * @param newPassword (optional) 
     * @return Success
     */
    changeUserPassword(userID?: string | undefined, newPassword?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/ChangeUserPassword?";
        if (userID === null)
            throw new globalThis.Error("The parameter 'userID' cannot be null.");
        else if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&";
        if (newPassword === null)
            throw new globalThis.Error("The parameter 'newPassword' cannot be null.");
        else if (newPassword !== undefined)
            url_ += "newPassword=" + encodeURIComponent("" + newPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangeUserPassword(_response);
        });
    }

    protected processChangeUserPassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userID (optional) 
     * @param verificationCode (optional) 
     * @return Success
     */
    verifyEmail(userID?: string | undefined, verificationCode?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/VerifyEmail?";
        if (userID === null)
            throw new globalThis.Error("The parameter 'userID' cannot be null.");
        else if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&";
        if (verificationCode === null)
            throw new globalThis.Error("The parameter 'verificationCode' cannot be null.");
        else if (verificationCode !== undefined)
            url_ += "verificationCode=" + encodeURIComponent("" + verificationCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVerifyEmail(_response);
        });
    }

    protected processVerifyEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userID (optional) 
     * @return Success
     */
    resendVerificationCode(userID?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/ResendVerificationCode?";
        if (userID === null)
            throw new globalThis.Error("The parameter 'userID' cannot be null.");
        else if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResendVerificationCode(_response);
        });
    }

    protected processResendVerificationCode(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userID (optional) 
     * @return Success
     */
    updateUserActiveStatus(userID?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/UpdateUserActiveStatus?";
        if (userID === null)
            throw new globalThis.Error("The parameter 'userID' cannot be null.");
        else if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUserActiveStatus(_response);
        });
    }

    protected processUpdateUserActiveStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param emailAddress (optional) 
     * @return Success
     */
    passwordReset(emailAddress?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/PasswordReset?";
        if (emailAddress === null)
            throw new globalThis.Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPasswordReset(_response);
        });
    }

    protected processPasswordReset(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalPasswordChange(body?: ExternalPasswordChangeModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/ExternalPasswordChange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExternalPasswordChange(_response);
        });
    }

    protected processExternalPasswordChange(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param rpmUserID (optional) 
     * @return Success
     */
    setRPMUserID(rpmUserID?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/SetRPMUserID?";
        if (rpmUserID === null)
            throw new globalThis.Error("The parameter 'rpmUserID' cannot be null.");
        else if (rpmUserID !== undefined)
            url_ += "rpmUserID=" + encodeURIComponent("" + rpmUserID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetRPMUserID(_response);
        });
    }

    protected processSetRPMUserID(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    migrateCoreAccount(body?: CoreMigrationRequestModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Users/MigrateCoreAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMigrateCoreAccount(_response);
        });
    }

    protected processMigrateCoreAccount(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            if (status == 509) {        
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 429) {
                return response.text().then((_responseText) => {
                return throwException(_responseText, status, _responseText, _headers);
                });
            } else if (status == 400) {
                return response.text().then((_responseText) => {
                throw new CPLError(CPLErrorTypes.NOT_FOUND);
                });
            } else {
                return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred", status, _responseText, _headers);
                });
            }
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class AppVersionModel implements IAppVersionModel {
    appVersionID?: number;
    version?: string | undefined;
    build?: string | undefined;
    osTypeID?: number;
    isObsolete?: boolean;
    isLive?: boolean;

    constructor(data?: IAppVersionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appVersionID = _data["appVersionID"];
            this.version = _data["version"];
            this.build = _data["build"];
            this.osTypeID = _data["osTypeID"];
            this.isObsolete = _data["isObsolete"];
            this.isLive = _data["isLive"];
        }
    }

    static fromJS(data: any): AppVersionModel {
        data = typeof data === 'object' ? data : {};
        let result = new AppVersionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appVersionID"] = this.appVersionID;
        data["version"] = this.version;
        data["build"] = this.build;
        data["osTypeID"] = this.osTypeID;
        data["isObsolete"] = this.isObsolete;
        data["isLive"] = this.isLive;
        return data;
    }
}

export interface IAppVersionModel {
    appVersionID?: number;
    version?: string | undefined;
    build?: string | undefined;
    osTypeID?: number;
    isObsolete?: boolean;
    isLive?: boolean;
}

export class AuthoriseMerchantResponseModel implements IAuthoriseMerchantResponseModel {
    redirectURL?: string | undefined;

    constructor(data?: IAuthoriseMerchantResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.redirectURL = _data["redirectURL"];
        }
    }

    static fromJS(data: any): AuthoriseMerchantResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthoriseMerchantResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["redirectURL"] = this.redirectURL;
        return data;
    }
}

export interface IAuthoriseMerchantResponseModel {
    redirectURL?: string | undefined;
}

export class CPLAuthTokenModel implements ICPLAuthTokenModel {
    token?: string | undefined;
    refreshToken?: string | undefined;
    expiresIn?: number;
    refreshClaims?: boolean;

    constructor(data?: ICPLAuthTokenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.refreshToken = _data["refreshToken"];
            this.expiresIn = _data["expiresIn"];
            this.refreshClaims = _data["refreshClaims"];
        }
    }

    static fromJS(data: any): CPLAuthTokenModel {
        data = typeof data === 'object' ? data : {};
        let result = new CPLAuthTokenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["refreshToken"] = this.refreshToken;
        data["expiresIn"] = this.expiresIn;
        data["refreshClaims"] = this.refreshClaims;
        return data;
    }
}

export interface ICPLAuthTokenModel {
    token?: string | undefined;
    refreshToken?: string | undefined;
    expiresIn?: number;
    refreshClaims?: boolean;
}

export class CPLConnectSessionTokensModel implements ICPLConnectSessionTokensModel {
    cplapiToken?: CPLAuthTokenModel;
    imageToken?: CPLAuthTokenModel;

    constructor(data?: ICPLConnectSessionTokensModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cplapiToken = _data["cplapiToken"] ? CPLAuthTokenModel.fromJS(_data["cplapiToken"]) : undefined as any;
            this.imageToken = _data["imageToken"] ? CPLAuthTokenModel.fromJS(_data["imageToken"]) : undefined as any;
        }
    }

    static fromJS(data: any): CPLConnectSessionTokensModel {
        data = typeof data === 'object' ? data : {};
        let result = new CPLConnectSessionTokensModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cplapiToken"] = this.cplapiToken ? this.cplapiToken.toJSON() : <any>undefined;
        data["imageToken"] = this.imageToken ? this.imageToken.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICPLConnectSessionTokensModel {
    cplapiToken?: CPLAuthTokenModel;
    imageToken?: CPLAuthTokenModel;
}

export class CPLMaintenanceDatesModel implements ICPLMaintenanceDatesModel {
    cplConnectMaintenanceDate?: Date | undefined;
    cplClientPortalMaintenanceDate?: Date | undefined;

    constructor(data?: ICPLMaintenanceDatesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cplConnectMaintenanceDate = _data["cplConnectMaintenanceDate"] ? new Date(_data["cplConnectMaintenanceDate"].toString()) : undefined as any;
            this.cplClientPortalMaintenanceDate = _data["cplClientPortalMaintenanceDate"] ? new Date(_data["cplClientPortalMaintenanceDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CPLMaintenanceDatesModel {
        data = typeof data === 'object' ? data : {};
        let result = new CPLMaintenanceDatesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cplConnectMaintenanceDate"] = this.cplConnectMaintenanceDate?.isValidDate() ? this.cplConnectMaintenanceDate.toISOString() : <any>undefined;
        data["cplClientPortalMaintenanceDate"] = this.cplClientPortalMaintenanceDate?.isValidDate() ? this.cplClientPortalMaintenanceDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICPLMaintenanceDatesModel {
    cplConnectMaintenanceDate?: Date | undefined;
    cplClientPortalMaintenanceDate?: Date | undefined;
}

export class ClientPortalCookiePreferencesModel implements IClientPortalCookiePreferencesModel {
    functionalEnabled?: boolean;
    analyticsEnabled?: boolean;
    dateUpdated?: Date;
    userAgent?: string | undefined;

    constructor(data?: IClientPortalCookiePreferencesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.functionalEnabled = _data["functionalEnabled"];
            this.analyticsEnabled = _data["analyticsEnabled"];
            this.dateUpdated = _data["dateUpdated"] ? new Date(_data["dateUpdated"].toString()) : undefined as any;
            this.userAgent = _data["userAgent"];
        }
    }

    static fromJS(data: any): ClientPortalCookiePreferencesModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalCookiePreferencesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["functionalEnabled"] = this.functionalEnabled;
        data["analyticsEnabled"] = this.analyticsEnabled;
        data["dateUpdated"] = this.dateUpdated?.isValidDate() ? this.dateUpdated.toISOString() : <any>undefined;
        data["userAgent"] = this.userAgent;
        return data;
    }
}

export interface IClientPortalCookiePreferencesModel {
    functionalEnabled?: boolean;
    analyticsEnabled?: boolean;
    dateUpdated?: Date;
    userAgent?: string | undefined;
}

export class ClientPortalLinkedClientAccountModel implements IClientPortalLinkedClientAccountModel {
    clientPortalUserClientMappingID?: number;
    clientID?: string;
    label?: string | undefined;

    constructor(data?: IClientPortalLinkedClientAccountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientPortalUserClientMappingID = _data["clientPortalUserClientMappingID"];
            this.clientID = _data["clientID"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): ClientPortalLinkedClientAccountModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalLinkedClientAccountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientPortalUserClientMappingID"] = this.clientPortalUserClientMappingID;
        data["clientID"] = this.clientID;
        data["label"] = this.label;
        return data;
    }
}

export interface IClientPortalLinkedClientAccountModel {
    clientPortalUserClientMappingID?: number;
    clientID?: string;
    label?: string | undefined;
}

export enum ClientPortalLogSourceType {
    Web = "Web",
}

export enum ClientPortalLogTypes {
    LogOn = "LogOn",
    LogOff = "LogOff",
    ChangePassword = "ChangePassword",
    ChangeEmail = "ChangeEmail",
    Change2FAMethod = "Change2FAMethod",
    InvoiceDownload = "InvoiceDownload",
    ChangeAccountSettings = "ChangeAccountSettings",
    PLInvoiceDownload = "PLInvoiceDownload",
    PaymentAttempt = "PaymentAttempt",
    PWPaymentAttempt = "PWPaymentAttempt",
    PWVote = "PWVote",
    DevelopmentNewsViewed = "DevelopmentNewsViewed",
    PMEmailAddressClicked = "PMEmailAddressClicked",
    DocumentDownloaded = "DocumentDownloaded",
    PasswordResetEmailSent = "PasswordResetEmailSent",
    CaseRaised = "CaseRaised",
    AddAccount = "AddAccount",
    RemoveAccount = "RemoveAccount",
    DirectDebitSetup = "DirectDebitSetup",
    EmailChangeLinkedAddress = "EmailChangeLinkedAddress",
    AddressChangeLinkedAddress = "AddressChangeLinkedAddress",
    AddEmailLinkedAddress = "AddEmailLinkedAddress",
    AddAddressLinkedAddress = "AddAddressLinkedAddress",
    DeleteAccount = "DeleteAccount",
}

export class ClientPortalSessionTokensModel implements IClientPortalSessionTokensModel {
    cplapiToken?: CPLAuthTokenModel;
    imageToken?: CPLAuthTokenModel;

    constructor(data?: IClientPortalSessionTokensModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cplapiToken = _data["cplapiToken"] ? CPLAuthTokenModel.fromJS(_data["cplapiToken"]) : undefined as any;
            this.imageToken = _data["imageToken"] ? CPLAuthTokenModel.fromJS(_data["imageToken"]) : undefined as any;
        }
    }

    static fromJS(data: any): ClientPortalSessionTokensModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalSessionTokensModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cplapiToken"] = this.cplapiToken ? this.cplapiToken.toJSON() : <any>undefined;
        data["imageToken"] = this.imageToken ? this.imageToken.toJSON() : <any>undefined;
        return data;
    }
}

export interface IClientPortalSessionTokensModel {
    cplapiToken?: CPLAuthTokenModel;
    imageToken?: CPLAuthTokenModel;
}

export class ClientPortalUserDetailsModel implements IClientPortalUserDetailsModel {
    firstName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: IClientPortalUserDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): ClientPortalUserDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalUserDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface IClientPortalUserDetailsModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export class ClientPortalUserLogModel implements IClientPortalUserLogModel {
    clientPortalUserID?: string;
    clientPortalLogTypeID?: ClientPortalLogTypes;
    clientID?: string | undefined;
    description?: string | undefined;
    clientPortalLogSourceTypeID?: ClientPortalLogSourceType;
    isImpersonator?: boolean;

    constructor(data?: IClientPortalUserLogModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientPortalUserID = _data["clientPortalUserID"];
            this.clientPortalLogTypeID = _data["clientPortalLogTypeID"];
            this.clientID = _data["clientID"];
            this.description = _data["description"];
            this.clientPortalLogSourceTypeID = _data["clientPortalLogSourceTypeID"];
            this.isImpersonator = _data["isImpersonator"];
        }
    }

    static fromJS(data: any): ClientPortalUserLogModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalUserLogModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientPortalUserID"] = this.clientPortalUserID;
        data["clientPortalLogTypeID"] = this.clientPortalLogTypeID;
        data["clientID"] = this.clientID;
        data["description"] = this.description;
        data["clientPortalLogSourceTypeID"] = this.clientPortalLogSourceTypeID;
        data["isImpersonator"] = this.isImpersonator;
        return data;
    }
}

export interface IClientPortalUserLogModel {
    clientPortalUserID?: string;
    clientPortalLogTypeID?: ClientPortalLogTypes;
    clientID?: string | undefined;
    description?: string | undefined;
    clientPortalLogSourceTypeID?: ClientPortalLogSourceType;
    isImpersonator?: boolean;
}

export class ClientPortalUserModel implements IClientPortalUserModel {
    clientPortalUserID?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    companyID?: string;
    termsAndConditionsAcceptanceDate?: Date | undefined;
    twoFactorAuthTypeID?: number;
    fullName?: string | undefined;
    accountDisabled?: boolean;
    passwordChangeRequired?: boolean;
    clientPortalUserUpdatedDate?: Date | undefined;
    updatedByUserDate?: Date | undefined;
    updatedBy?: string | undefined;

    constructor(data?: IClientPortalUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientPortalUserID = _data["clientPortalUserID"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.emailAddress = _data["emailAddress"];
            this.companyID = _data["companyID"];
            this.termsAndConditionsAcceptanceDate = _data["termsAndConditionsAcceptanceDate"] ? new Date(_data["termsAndConditionsAcceptanceDate"].toString()) : undefined as any;
            this.twoFactorAuthTypeID = _data["twoFactorAuthTypeID"];
            this.fullName = _data["fullName"];
            this.accountDisabled = _data["accountDisabled"];
            this.passwordChangeRequired = _data["passwordChangeRequired"];
            this.clientPortalUserUpdatedDate = _data["clientPortalUserUpdatedDate"] ? new Date(_data["clientPortalUserUpdatedDate"].toString()) : undefined as any;
            this.updatedByUserDate = _data["updatedByUserDate"] ? new Date(_data["updatedByUserDate"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): ClientPortalUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientPortalUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientPortalUserID"] = this.clientPortalUserID;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        data["companyID"] = this.companyID;
        data["termsAndConditionsAcceptanceDate"] = this.termsAndConditionsAcceptanceDate?.isValidDate() ? this.termsAndConditionsAcceptanceDate.toISOString() : <any>undefined;
        data["twoFactorAuthTypeID"] = this.twoFactorAuthTypeID;
        data["fullName"] = this.fullName;
        data["accountDisabled"] = this.accountDisabled;
        data["passwordChangeRequired"] = this.passwordChangeRequired;
        data["clientPortalUserUpdatedDate"] = this.clientPortalUserUpdatedDate?.isValidDate() ? this.clientPortalUserUpdatedDate.toISOString() : <any>undefined;
        data["updatedByUserDate"] = this.updatedByUserDate?.isValidDate() ? this.updatedByUserDate.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IClientPortalUserModel {
    clientPortalUserID?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    companyID?: string;
    termsAndConditionsAcceptanceDate?: Date | undefined;
    twoFactorAuthTypeID?: number;
    fullName?: string | undefined;
    accountDisabled?: boolean;
    passwordChangeRequired?: boolean;
    clientPortalUserUpdatedDate?: Date | undefined;
    updatedByUserDate?: Date | undefined;
    updatedBy?: string | undefined;
}

export class CompanyBrandingModel implements ICompanyBrandingModel {
    companyBrandingID?: number;
    companyName?: string | undefined;
    faviconUrl?: string | undefined;
    logoUrl?: string | undefined;
    bodyFontUrl?: string | undefined;
    headerFontUrl?: string | undefined;
    companyBrandingFileUrl?: string | undefined;
    isGeneratedCSSFile?: boolean;
    clientPortalName?: string | undefined;
    navbarBackgroundColour?: string | undefined;
    navbarTextColour?: string | undefined;
    navbarButtonColour?: string | undefined;
    navbarButtonTextColour?: string | undefined;
    navbarIconColour?: string | undefined;
    footerBackgroundColour?: string | undefined;
    footerTextColour?: string | undefined;
    footerButtonColour?: string | undefined;
    footerButtonTextColour?: string | undefined;
    toolbarBackgroundColour?: string | undefined;
    toolbarTextColour?: string | undefined;
    toolbarButtonColour?: string | undefined;
    toolbarButtonTextColour?: string | undefined;
    buttonPrimaryColour?: string | undefined;
    buttonSecondaryColour?: string | undefined;
    buttonSuccessColour?: string | undefined;
    buttonDangerColour?: string | undefined;
    buttonPrimaryTextColour?: string | undefined;
    buttonSecondaryTextColour?: string | undefined;
    buttonSuccessTextColour?: string | undefined;
    buttonDangerTextColour?: string | undefined;
    brandPrimaryColour?: string | undefined;
    brandSecondaryColour?: string | undefined;
    brandTertiaryColour?: string | undefined;
    isHeaderTextBold?: boolean;
    isHeaderTextItalic?: boolean;
    isHeaderTextUnderlined?: boolean;
    fontHeadingColour?: string | undefined;
    fontBodyColour?: string | undefined;

    constructor(data?: ICompanyBrandingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyBrandingID = _data["companyBrandingID"];
            this.companyName = _data["companyName"];
            this.faviconUrl = _data["faviconUrl"];
            this.logoUrl = _data["logoUrl"];
            this.bodyFontUrl = _data["bodyFontUrl"];
            this.headerFontUrl = _data["headerFontUrl"];
            this.companyBrandingFileUrl = _data["companyBrandingFileUrl"];
            this.isGeneratedCSSFile = _data["isGeneratedCSSFile"];
            this.clientPortalName = _data["clientPortalName"];
            this.navbarBackgroundColour = _data["navbarBackgroundColour"];
            this.navbarTextColour = _data["navbarTextColour"];
            this.navbarButtonColour = _data["navbarButtonColour"];
            this.navbarButtonTextColour = _data["navbarButtonTextColour"];
            this.navbarIconColour = _data["navbarIconColour"];
            this.footerBackgroundColour = _data["footerBackgroundColour"];
            this.footerTextColour = _data["footerTextColour"];
            this.footerButtonColour = _data["footerButtonColour"];
            this.footerButtonTextColour = _data["footerButtonTextColour"];
            this.toolbarBackgroundColour = _data["toolbarBackgroundColour"];
            this.toolbarTextColour = _data["toolbarTextColour"];
            this.toolbarButtonColour = _data["toolbarButtonColour"];
            this.toolbarButtonTextColour = _data["toolbarButtonTextColour"];
            this.buttonPrimaryColour = _data["buttonPrimaryColour"];
            this.buttonSecondaryColour = _data["buttonSecondaryColour"];
            this.buttonSuccessColour = _data["buttonSuccessColour"];
            this.buttonDangerColour = _data["buttonDangerColour"];
            this.buttonPrimaryTextColour = _data["buttonPrimaryTextColour"];
            this.buttonSecondaryTextColour = _data["buttonSecondaryTextColour"];
            this.buttonSuccessTextColour = _data["buttonSuccessTextColour"];
            this.buttonDangerTextColour = _data["buttonDangerTextColour"];
            this.brandPrimaryColour = _data["brandPrimaryColour"];
            this.brandSecondaryColour = _data["brandSecondaryColour"];
            this.brandTertiaryColour = _data["brandTertiaryColour"];
            this.isHeaderTextBold = _data["isHeaderTextBold"];
            this.isHeaderTextItalic = _data["isHeaderTextItalic"];
            this.isHeaderTextUnderlined = _data["isHeaderTextUnderlined"];
            this.fontHeadingColour = _data["fontHeadingColour"];
            this.fontBodyColour = _data["fontBodyColour"];
        }
    }

    static fromJS(data: any): CompanyBrandingModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyBrandingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyBrandingID"] = this.companyBrandingID;
        data["companyName"] = this.companyName;
        data["faviconUrl"] = this.faviconUrl;
        data["logoUrl"] = this.logoUrl;
        data["bodyFontUrl"] = this.bodyFontUrl;
        data["headerFontUrl"] = this.headerFontUrl;
        data["companyBrandingFileUrl"] = this.companyBrandingFileUrl;
        data["isGeneratedCSSFile"] = this.isGeneratedCSSFile;
        data["clientPortalName"] = this.clientPortalName;
        data["navbarBackgroundColour"] = this.navbarBackgroundColour;
        data["navbarTextColour"] = this.navbarTextColour;
        data["navbarButtonColour"] = this.navbarButtonColour;
        data["navbarButtonTextColour"] = this.navbarButtonTextColour;
        data["navbarIconColour"] = this.navbarIconColour;
        data["footerBackgroundColour"] = this.footerBackgroundColour;
        data["footerTextColour"] = this.footerTextColour;
        data["footerButtonColour"] = this.footerButtonColour;
        data["footerButtonTextColour"] = this.footerButtonTextColour;
        data["toolbarBackgroundColour"] = this.toolbarBackgroundColour;
        data["toolbarTextColour"] = this.toolbarTextColour;
        data["toolbarButtonColour"] = this.toolbarButtonColour;
        data["toolbarButtonTextColour"] = this.toolbarButtonTextColour;
        data["buttonPrimaryColour"] = this.buttonPrimaryColour;
        data["buttonSecondaryColour"] = this.buttonSecondaryColour;
        data["buttonSuccessColour"] = this.buttonSuccessColour;
        data["buttonDangerColour"] = this.buttonDangerColour;
        data["buttonPrimaryTextColour"] = this.buttonPrimaryTextColour;
        data["buttonSecondaryTextColour"] = this.buttonSecondaryTextColour;
        data["buttonSuccessTextColour"] = this.buttonSuccessTextColour;
        data["buttonDangerTextColour"] = this.buttonDangerTextColour;
        data["brandPrimaryColour"] = this.brandPrimaryColour;
        data["brandSecondaryColour"] = this.brandSecondaryColour;
        data["brandTertiaryColour"] = this.brandTertiaryColour;
        data["isHeaderTextBold"] = this.isHeaderTextBold;
        data["isHeaderTextItalic"] = this.isHeaderTextItalic;
        data["isHeaderTextUnderlined"] = this.isHeaderTextUnderlined;
        data["fontHeadingColour"] = this.fontHeadingColour;
        data["fontBodyColour"] = this.fontBodyColour;
        return data;
    }
}

export interface ICompanyBrandingModel {
    companyBrandingID?: number;
    companyName?: string | undefined;
    faviconUrl?: string | undefined;
    logoUrl?: string | undefined;
    bodyFontUrl?: string | undefined;
    headerFontUrl?: string | undefined;
    companyBrandingFileUrl?: string | undefined;
    isGeneratedCSSFile?: boolean;
    clientPortalName?: string | undefined;
    navbarBackgroundColour?: string | undefined;
    navbarTextColour?: string | undefined;
    navbarButtonColour?: string | undefined;
    navbarButtonTextColour?: string | undefined;
    navbarIconColour?: string | undefined;
    footerBackgroundColour?: string | undefined;
    footerTextColour?: string | undefined;
    footerButtonColour?: string | undefined;
    footerButtonTextColour?: string | undefined;
    toolbarBackgroundColour?: string | undefined;
    toolbarTextColour?: string | undefined;
    toolbarButtonColour?: string | undefined;
    toolbarButtonTextColour?: string | undefined;
    buttonPrimaryColour?: string | undefined;
    buttonSecondaryColour?: string | undefined;
    buttonSuccessColour?: string | undefined;
    buttonDangerColour?: string | undefined;
    buttonPrimaryTextColour?: string | undefined;
    buttonSecondaryTextColour?: string | undefined;
    buttonSuccessTextColour?: string | undefined;
    buttonDangerTextColour?: string | undefined;
    brandPrimaryColour?: string | undefined;
    brandSecondaryColour?: string | undefined;
    brandTertiaryColour?: string | undefined;
    isHeaderTextBold?: boolean;
    isHeaderTextItalic?: boolean;
    isHeaderTextUnderlined?: boolean;
    fontHeadingColour?: string | undefined;
    fontBodyColour?: string | undefined;
}

export class CompanyBrandingUrlModel implements ICompanyBrandingUrlModel {
    cssFileURL?: string | undefined;

    constructor(data?: ICompanyBrandingUrlModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cssFileURL = _data["cssFileURL"];
        }
    }

    static fromJS(data: any): CompanyBrandingUrlModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyBrandingUrlModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cssFileURL"] = this.cssFileURL;
        return data;
    }
}

export interface ICompanyBrandingUrlModel {
    cssFileURL?: string | undefined;
}

export class CompanyLicenceModel implements ICompanyLicenceModel {
    cplUnitCount?: number | undefined;
    cplUnitLimit?: number | undefined;
    licenceExceeded?: boolean;
    licenceWarning?: boolean;

    constructor(data?: ICompanyLicenceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cplUnitCount = _data["cplUnitCount"];
            this.cplUnitLimit = _data["cplUnitLimit"];
            this.licenceExceeded = _data["licenceExceeded"];
            this.licenceWarning = _data["licenceWarning"];
        }
    }

    static fromJS(data: any): CompanyLicenceModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyLicenceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cplUnitCount"] = this.cplUnitCount;
        data["cplUnitLimit"] = this.cplUnitLimit;
        data["licenceExceeded"] = this.licenceExceeded;
        data["licenceWarning"] = this.licenceWarning;
        return data;
    }
}

export interface ICompanyLicenceModel {
    cplUnitCount?: number | undefined;
    cplUnitLimit?: number | undefined;
    licenceExceeded?: boolean;
    licenceWarning?: boolean;
}

export class CompanyModel implements ICompanyModel {
    companyID?: string;
    companyName?: string | undefined;
    logoURL?: string | undefined;
    clientPortalURL?: string | undefined;

    constructor(data?: ICompanyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyID = _data["companyID"];
            this.companyName = _data["companyName"];
            this.logoURL = _data["logoURL"];
            this.clientPortalURL = _data["clientPortalURL"];
        }
    }

    static fromJS(data: any): CompanyModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyID"] = this.companyID;
        data["companyName"] = this.companyName;
        data["logoURL"] = this.logoURL;
        data["clientPortalURL"] = this.clientPortalURL;
        return data;
    }
}

export interface ICompanyModel {
    companyID?: string;
    companyName?: string | undefined;
    logoURL?: string | undefined;
    clientPortalURL?: string | undefined;
}

export class CoreMigrationRequestModel implements ICoreMigrationRequestModel {
    username?: string | undefined;
    password?: string | undefined;
    rpmUserID?: string;

    constructor(data?: ICoreMigrationRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.rpmUserID = _data["rpmUserID"];
        }
    }

    static fromJS(data: any): CoreMigrationRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CoreMigrationRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["rpmUserID"] = this.rpmUserID;
        return data;
    }
}

export interface ICoreMigrationRequestModel {
    username?: string | undefined;
    password?: string | undefined;
    rpmUserID?: string;
}

export class ExternalAccessTokenModel implements IExternalAccessTokenModel {
    token?: string | undefined;
    accessPath?: string | undefined;
    expiresIn?: number;

    constructor(data?: IExternalAccessTokenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.accessPath = _data["accessPath"];
            this.expiresIn = _data["expiresIn"];
        }
    }

    static fromJS(data: any): ExternalAccessTokenModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAccessTokenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["accessPath"] = this.accessPath;
        data["expiresIn"] = this.expiresIn;
        return data;
    }
}

export interface IExternalAccessTokenModel {
    token?: string | undefined;
    accessPath?: string | undefined;
    expiresIn?: number;
}

export class ExternalPasswordChangeModel implements IExternalPasswordChangeModel {
    singleUseToken?: string | undefined;
    newPassword?: string | undefined;

    constructor(data?: IExternalPasswordChangeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.singleUseToken = _data["singleUseToken"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ExternalPasswordChangeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalPasswordChangeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["singleUseToken"] = this.singleUseToken;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IExternalPasswordChangeModel {
    singleUseToken?: string | undefined;
    newPassword?: string | undefined;
}

export class ImpersonationHandoffModel implements IImpersonationHandoffModel {
    reference?: string;
    clientPortalURL?: string | undefined;

    constructor(data?: IImpersonationHandoffModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reference = _data["reference"];
            this.clientPortalURL = _data["clientPortalURL"];
        }
    }

    static fromJS(data: any): ImpersonationHandoffModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonationHandoffModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reference"] = this.reference;
        data["clientPortalURL"] = this.clientPortalURL;
        return data;
    }
}

export interface IImpersonationHandoffModel {
    reference?: string;
    clientPortalURL?: string | undefined;
}

export class ImpersonationTokenModel implements IImpersonationTokenModel {
    impersonatedUserName?: string | undefined;
    twoFactorAuthType?: number;
    impersonatedUserToken?: string | undefined;
    impersonatorUserToken?: CPLAuthTokenModel;
    clientPortalURL?: string | undefined;

    constructor(data?: IImpersonationTokenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.impersonatedUserName = _data["impersonatedUserName"];
            this.twoFactorAuthType = _data["twoFactorAuthType"];
            this.impersonatedUserToken = _data["impersonatedUserToken"];
            this.impersonatorUserToken = _data["impersonatorUserToken"] ? CPLAuthTokenModel.fromJS(_data["impersonatorUserToken"]) : undefined as any;
            this.clientPortalURL = _data["clientPortalURL"];
        }
    }

    static fromJS(data: any): ImpersonationTokenModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonationTokenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["impersonatedUserName"] = this.impersonatedUserName;
        data["twoFactorAuthType"] = this.twoFactorAuthType;
        data["impersonatedUserToken"] = this.impersonatedUserToken;
        data["impersonatorUserToken"] = this.impersonatorUserToken ? this.impersonatorUserToken.toJSON() : <any>undefined;
        data["clientPortalURL"] = this.clientPortalURL;
        return data;
    }
}

export interface IImpersonationTokenModel {
    impersonatedUserName?: string | undefined;
    twoFactorAuthType?: number;
    impersonatedUserToken?: string | undefined;
    impersonatorUserToken?: CPLAuthTokenModel;
    clientPortalURL?: string | undefined;
}

export class LoginRequestModel implements ILoginRequestModel {
    companyID?: string;
    username?: string | undefined;
    emailAddress?: string | undefined;
    password?: string | undefined;
    oneTimePassword?: string | undefined;

    constructor(data?: ILoginRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyID = _data["companyID"];
            this.username = _data["username"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.oneTimePassword = _data["oneTimePassword"];
        }
    }

    static fromJS(data: any): LoginRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyID"] = this.companyID;
        data["username"] = this.username;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["oneTimePassword"] = this.oneTimePassword;
        return data;
    }
}

export interface ILoginRequestModel {
    companyID?: string;
    username?: string | undefined;
    emailAddress?: string | undefined;
    password?: string | undefined;
    oneTimePassword?: string | undefined;
}

export class LoginScreenNarrativeModel implements ILoginScreenNarrativeModel {
    loginScreenNarrativeID?: number;
    pageDescription?: string | undefined;

    constructor(data?: ILoginScreenNarrativeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loginScreenNarrativeID = _data["loginScreenNarrativeID"];
            this.pageDescription = _data["pageDescription"];
        }
    }

    static fromJS(data: any): LoginScreenNarrativeModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoginScreenNarrativeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loginScreenNarrativeID"] = this.loginScreenNarrativeID;
        data["pageDescription"] = this.pageDescription;
        return data;
    }
}

export interface ILoginScreenNarrativeModel {
    loginScreenNarrativeID?: number;
    pageDescription?: string | undefined;
}

export class ModuleModel implements IModuleModel {
    moduleID?: number;
    moduleName?: string | undefined;

    constructor(data?: IModuleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.moduleID = _data["moduleID"];
            this.moduleName = _data["moduleName"];
        }
    }

    static fromJS(data: any): ModuleModel {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["moduleID"] = this.moduleID;
        data["moduleName"] = this.moduleName;
        return data;
    }
}

export interface IModuleModel {
    moduleID?: number;
    moduleName?: string | undefined;
}

export class NewClientPortalUserModel implements INewClientPortalUserModel {
    emailAddress?: string | undefined;
    companyID?: string;
    emailVerificationCode?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    password?: string | undefined;

    constructor(data?: INewClientPortalUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.companyID = _data["companyID"];
            this.emailVerificationCode = _data["emailVerificationCode"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): NewClientPortalUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewClientPortalUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["companyID"] = this.companyID;
        data["emailVerificationCode"] = this.emailVerificationCode;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["password"] = this.password;
        return data;
    }
}

export interface INewClientPortalUserModel {
    emailAddress?: string | undefined;
    companyID?: string;
    emailVerificationCode?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    password?: string | undefined;
}

export class NewUserModel implements INewUserModel {
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    telephoneNumber?: string | undefined;
    createCoreUser?: boolean;
    rpmUserId?: string | undefined;

    constructor(data?: INewUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.telephoneNumber = _data["telephoneNumber"];
            this.createCoreUser = _data["createCoreUser"];
            this.rpmUserId = _data["rpmUserId"];
        }
    }

    static fromJS(data: any): NewUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["telephoneNumber"] = this.telephoneNumber;
        data["createCoreUser"] = this.createCoreUser;
        data["rpmUserId"] = this.rpmUserId;
        return data;
    }
}

export interface INewUserModel {
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    telephoneNumber?: string | undefined;
    createCoreUser?: boolean;
    rpmUserId?: string | undefined;
}

export enum NotificationStyles {
    Success = "Success",
    Info = "Info",
    Warning = "Warning",
    Danger = "Danger",
}

export enum NotificationTypes {
    Toast = "Toast",
    Alert = "Alert",
}

export class PermissionCategoryModel implements IPermissionCategoryModel {
    permissionCategoryID?: number;
    name?: string | undefined;

    constructor(data?: IPermissionCategoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.permissionCategoryID = _data["permissionCategoryID"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PermissionCategoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionCategoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permissionCategoryID"] = this.permissionCategoryID;
        data["name"] = this.name;
        return data;
    }
}

export interface IPermissionCategoryModel {
    permissionCategoryID?: number;
    name?: string | undefined;
}

export class PermissionManagementMatrixCell implements IPermissionManagementMatrixCell {
    permissionAssignmentID?: number | undefined;
    permissionID?: number;
    permissionGranted?: boolean | undefined;

    constructor(data?: IPermissionManagementMatrixCell) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.permissionAssignmentID = _data["permissionAssignmentID"];
            this.permissionID = _data["permissionID"];
            this.permissionGranted = _data["permissionGranted"];
        }
    }

    static fromJS(data: any): PermissionManagementMatrixCell {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionManagementMatrixCell();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permissionAssignmentID"] = this.permissionAssignmentID;
        data["permissionID"] = this.permissionID;
        data["permissionGranted"] = this.permissionGranted;
        return data;
    }
}

export interface IPermissionManagementMatrixCell {
    permissionAssignmentID?: number | undefined;
    permissionID?: number;
    permissionGranted?: boolean | undefined;
}

export class PermissionManagementMatrixModel implements IPermissionManagementMatrixModel {
    permissionCategory?: number;
    rows?: PermissionManagmentMatrixRow[] | undefined;

    constructor(data?: IPermissionManagementMatrixModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.permissionCategory = _data["permissionCategory"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(PermissionManagmentMatrixRow.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionManagementMatrixModel {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionManagementMatrixModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permissionCategory"] = this.permissionCategory;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPermissionManagementMatrixModel {
    permissionCategory?: number;
    rows?: PermissionManagmentMatrixRow[] | undefined;
}

export class PermissionManagmentMatrixRow implements IPermissionManagmentMatrixRow {
    rowID?: number;
    name?: string | undefined;
    userID?: string | undefined;
    userGroupID?: number | undefined;
    assignments?: PermissionManagementMatrixCell[] | undefined;

    constructor(data?: IPermissionManagmentMatrixRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowID = _data["rowID"];
            this.name = _data["name"];
            this.userID = _data["userID"];
            this.userGroupID = _data["userGroupID"];
            if (Array.isArray(_data["assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["assignments"])
                    this.assignments!.push(PermissionManagementMatrixCell.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionManagmentMatrixRow {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionManagmentMatrixRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowID"] = this.rowID;
        data["name"] = this.name;
        data["userID"] = this.userID;
        data["userGroupID"] = this.userGroupID;
        if (Array.isArray(this.assignments)) {
            data["assignments"] = [];
            for (let item of this.assignments)
                data["assignments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPermissionManagmentMatrixRow {
    rowID?: number;
    name?: string | undefined;
    userID?: string | undefined;
    userGroupID?: number | undefined;
    assignments?: PermissionManagementMatrixCell[] | undefined;
}

export class PermissionModel implements IPermissionModel {
    permissionID?: number;
    permissionCategoryID?: number;
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: IPermissionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.permissionID = _data["permissionID"];
            this.permissionCategoryID = _data["permissionCategoryID"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PermissionModel {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permissionID"] = this.permissionID;
        data["permissionCategoryID"] = this.permissionCategoryID;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IPermissionModel {
    permissionID?: number;
    permissionCategoryID?: number;
    name?: string | undefined;
    description?: string | undefined;
}

export class PermissionWithPermissionCategoryModel implements IPermissionWithPermissionCategoryModel {
    permissionCategoryID?: number;
    permissionCategoryName?: string | undefined;
    permissionID?: number;
    name?: string | undefined;
    parentCategoryID?: number | undefined;

    constructor(data?: IPermissionWithPermissionCategoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.permissionCategoryID = _data["permissionCategoryID"];
            this.permissionCategoryName = _data["permissionCategoryName"];
            this.permissionID = _data["permissionID"];
            this.name = _data["name"];
            this.parentCategoryID = _data["parentCategoryID"];
        }
    }

    static fromJS(data: any): PermissionWithPermissionCategoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionWithPermissionCategoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permissionCategoryID"] = this.permissionCategoryID;
        data["permissionCategoryName"] = this.permissionCategoryName;
        data["permissionID"] = this.permissionID;
        data["name"] = this.name;
        data["parentCategoryID"] = this.parentCategoryID;
        return data;
    }
}

export interface IPermissionWithPermissionCategoryModel {
    permissionCategoryID?: number;
    permissionCategoryName?: string | undefined;
    permissionID?: number;
    name?: string | undefined;
    parentCategoryID?: number | undefined;
}

export class TwoFactorAuthModel implements ITwoFactorAuthModel {
    twoFactorAuthTypeID?: number;

    constructor(data?: ITwoFactorAuthModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.twoFactorAuthTypeID = _data["twoFactorAuthTypeID"];
        }
    }

    static fromJS(data: any): TwoFactorAuthModel {
        data = typeof data === 'object' ? data : {};
        let result = new TwoFactorAuthModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["twoFactorAuthTypeID"] = this.twoFactorAuthTypeID;
        return data;
    }
}

export interface ITwoFactorAuthModel {
    twoFactorAuthTypeID?: number;
}

export class TwoFactorAuthSetupModel implements ITwoFactorAuthSetupModel {
    qrCodeImageURL?: string | undefined;
    manualSetupCode?: string | undefined;

    constructor(data?: ITwoFactorAuthSetupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qrCodeImageURL = _data["qrCodeImageURL"];
            this.manualSetupCode = _data["manualSetupCode"];
        }
    }

    static fromJS(data: any): TwoFactorAuthSetupModel {
        data = typeof data === 'object' ? data : {};
        let result = new TwoFactorAuthSetupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCodeImageURL"] = this.qrCodeImageURL;
        data["manualSetupCode"] = this.manualSetupCode;
        return data;
    }
}

export interface ITwoFactorAuthSetupModel {
    qrCodeImageURL?: string | undefined;
    manualSetupCode?: string | undefined;
}

export enum TwoFactorAuthenticationResponseType {
    Verified = "Verified",
    Unverified = "Unverified",
    Expired = "Expired",
}

export class UserGroupModel implements IUserGroupModel {
    userGroupID?: number;
    groupName?: string | undefined;
    companyID?: string;
    createdDate?: Date;
    createdBy?: string;
    updatedDate?: Date | undefined;
    updatedBy?: string | undefined;
    deleted?: boolean;

    constructor(data?: IUserGroupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userGroupID = _data["userGroupID"];
            this.groupName = _data["groupName"];
            this.companyID = _data["companyID"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
            this.deleted = _data["deleted"];
        }
    }

    static fromJS(data: any): UserGroupModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userGroupID"] = this.userGroupID;
        data["groupName"] = this.groupName;
        data["companyID"] = this.companyID;
        data["createdDate"] = this.createdDate?.isValidDate() ? this.createdDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedDate"] = this.updatedDate?.isValidDate() ? this.updatedDate.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["deleted"] = this.deleted;
        return data;
    }
}

export interface IUserGroupModel {
    userGroupID?: number;
    groupName?: string | undefined;
    companyID?: string;
    createdDate?: Date;
    createdBy?: string;
    updatedDate?: Date | undefined;
    updatedBy?: string | undefined;
    deleted?: boolean;
}

export class UserModel implements IUserModel {
    userID?: string;
    emailAddress?: string | undefined;
    companyID?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    telephoneNumber?: string | undefined;
    profileImage?: string | undefined;
    passwordChangeRequired?: boolean;
    firstAccessDate?: Date | undefined;
    isVerified?: boolean;
    inactive?: boolean;
    superUser?: boolean;
    rpmUserID?: string | undefined;

    constructor(data?: IUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userID = _data["userID"];
            this.emailAddress = _data["emailAddress"];
            this.companyID = _data["companyID"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.telephoneNumber = _data["telephoneNumber"];
            this.profileImage = _data["profileImage"];
            this.passwordChangeRequired = _data["passwordChangeRequired"];
            this.firstAccessDate = _data["firstAccessDate"] ? new Date(_data["firstAccessDate"].toString()) : undefined as any;
            this.isVerified = _data["isVerified"];
            this.inactive = _data["inactive"];
            this.superUser = _data["superUser"];
            this.rpmUserID = _data["rpmUserID"];
        }
    }

    static fromJS(data: any): UserModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userID"] = this.userID;
        data["emailAddress"] = this.emailAddress;
        data["companyID"] = this.companyID;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["telephoneNumber"] = this.telephoneNumber;
        data["profileImage"] = this.profileImage;
        data["passwordChangeRequired"] = this.passwordChangeRequired;
        data["firstAccessDate"] = this.firstAccessDate?.isValidDate() ? this.firstAccessDate.toISOString() : <any>undefined;
        data["isVerified"] = this.isVerified;
        data["inactive"] = this.inactive;
        data["superUser"] = this.superUser;
        data["rpmUserID"] = this.rpmUserID;
        return data;
    }
}

export interface IUserModel {
    userID?: string;
    emailAddress?: string | undefined;
    companyID?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    telephoneNumber?: string | undefined;
    profileImage?: string | undefined;
    passwordChangeRequired?: boolean;
    firstAccessDate?: Date | undefined;
    isVerified?: boolean;
    inactive?: boolean;
    superUser?: boolean;
    rpmUserID?: string | undefined;
}

export class UserPermissionModel implements IUserPermissionModel {
    permissionID?: number;
    name?: string | undefined;
    permissionAssignmentID?: number;
    source?: string | undefined;
    granted?: boolean;
    canDelete?: boolean;

    constructor(data?: IUserPermissionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.permissionID = _data["permissionID"];
            this.name = _data["name"];
            this.permissionAssignmentID = _data["permissionAssignmentID"];
            this.source = _data["source"];
            this.granted = _data["granted"];
            this.canDelete = _data["canDelete"];
        }
    }

    static fromJS(data: any): UserPermissionModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permissionID"] = this.permissionID;
        data["name"] = this.name;
        data["permissionAssignmentID"] = this.permissionAssignmentID;
        data["source"] = this.source;
        data["granted"] = this.granted;
        data["canDelete"] = this.canDelete;
        return data;
    }
}

export interface IUserPermissionModel {
    permissionID?: number;
    name?: string | undefined;
    permissionAssignmentID?: number;
    source?: string | undefined;
    granted?: boolean;
    canDelete?: boolean;
}

export class VerifyClientPortalUserResponse implements IVerifyClientPortalUserResponse {
    authenticationResponseType?: TwoFactorAuthenticationResponseType;
    sessionTokens?: ClientPortalSessionTokensModel;

    constructor(data?: IVerifyClientPortalUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authenticationResponseType = _data["authenticationResponseType"];
            this.sessionTokens = _data["sessionTokens"] ? ClientPortalSessionTokensModel.fromJS(_data["sessionTokens"]) : undefined as any;
        }
    }

    static fromJS(data: any): VerifyClientPortalUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyClientPortalUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authenticationResponseType"] = this.authenticationResponseType;
        data["sessionTokens"] = this.sessionTokens ? this.sessionTokens.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVerifyClientPortalUserResponse {
    authenticationResponseType?: TwoFactorAuthenticationResponseType;
    sessionTokens?: ClientPortalSessionTokensModel;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

/* eslint @typescript-eslint/no-unused-vars: 0 */